
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gf7Jt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $3izAL = parcelRequire("3izAL");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");


var $5dDC4 = parcelRequire("5dDC4");

var $4zyjT = parcelRequire("4zyjT");

var $a96iv = parcelRequire("a96iv");

var $hjUDQ = parcelRequire("hjUDQ");

var $cfM7x = parcelRequire("cfM7x");











var $f8dGE = parcelRequire("f8dGE");


var $iwjSV = parcelRequire("iwjSV");


var $hiHdh = parcelRequire("hiHdh");


var $6THkE = parcelRequire("6THkE");


var $8Yw12 = parcelRequire("8Yw12");




const $bcbc0d6f4b7dc8cf$var$bfsTraverse = (items, callback)=>{
    const queue = [
        ...items
    ];
    while(queue.length > 0){
        const currentItem = queue.shift();
        if (callback(currentItem)) break;
        if (currentItem.type === (0, $8Yw12.ITEM).MENU && currentItem.childItems) queue.push(...currentItem.childItems);
    }
    return items;
};
const $bcbc0d6f4b7dc8cf$export$133e0070ec60504c = (items, item, parentId, position)=>{
    const addItemToParentInPlace = (itemsToTraverse, parentId, item, position)=>{
        return $bcbc0d6f4b7dc8cf$var$bfsTraverse(itemsToTraverse, (currentItem)=>{
            if (currentItem.itemId === parentId && currentItem.type === (0, $8Yw12.ITEM).MENU) {
                if (position !== undefined && position >= 0 && position <= currentItem.childItems.length) currentItem.childItems.splice(position, 0, item);
                else currentItem.childItems = [
                    ...currentItem.childItems || [],
                    item
                ];
                return true;
            }
            return false;
        });
    };
    let newItems;
    if (parentId !== undefined) newItems = addItemToParentInPlace(items, parentId, item, position);
    else {
        const itemsLength = items.length;
        const newPosition = position !== undefined && position >= 0 && position <= itemsLength ? position : itemsLength;
        newItems = [
            ...items
        ];
        newItems.splice(newPosition, 0, item);
    }
    return newItems;
};
const $bcbc0d6f4b7dc8cf$export$2d1285fd35af5519 = (items, updatedItem)=>{
    return $bcbc0d6f4b7dc8cf$var$bfsTraverse(items, (currentItem)=>{
        if (currentItem.itemId === updatedItem.itemId) {
            Object.assign(currentItem, updatedItem);
            return true;
        }
        return false;
    });
};
const $bcbc0d6f4b7dc8cf$export$49f42e821420f72e = (items, itemId)=>{
    return items.map((item)=>{
        if (item.type === (0, $8Yw12.ITEM).MENU && item.childItems) item.childItems = $bcbc0d6f4b7dc8cf$export$49f42e821420f72e(item.childItems, itemId);
        return item;
    }).filter((item)=>item.itemId !== itemId);
};


const $5a630f948a937af8$var$MAXIMUM_ITEM_LIMIT = 50;
const $5a630f948a937af8$var$MAXIMUM_NESTING_LEVELS = 5;
const $5a630f948a937af8$export$8555315c03db9dc2 = ()=>$5a630f948a937af8$var$MAXIMUM_ITEM_LIMIT;
const $5a630f948a937af8$export$3fcb5b76d26bf473 = ()=>$5a630f948a937af8$var$MAXIMUM_NESTING_LEVELS;
const $5a630f948a937af8$export$b503abd6de82eca1 = (items)=>{
    return items?.reduce((acc, item)=>{
        return acc + 1 + $5a630f948a937af8$export$b503abd6de82eca1(item?.childItems);
    }, 0) || 0;
};
const $5a630f948a937af8$var$fetchLocalIdMacroParameters = (editorActions, localId)=>{
    const localIdNode = editorActions?.getNodeByLocalId?.(localId)?.toJSON();
    const params = localIdNode?.attrs?.parameters;
    // Return a copy of the params object if it exists, otherwise return null
    return params ? {
        ...params
    } : null;
};
const $5a630f948a937af8$export$42f5e9ab021856ba = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        itemId: (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))(),
        link: '',
        title: '',
        type: (0, $8Yw12.ITEM).LINK
    });
const $5a630f948a937af8$export$8623c79a5744076b = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        itemId: (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))(),
        childItems: [],
        title: '',
        type: (0, $8Yw12.ITEM).MENU
    });
const $5a630f948a937af8$export$6c8e1d57a494d583 = (itemsToValidate)=>{
    if (!itemsToValidate || !Array.isArray(itemsToValidate)) return [];
    return itemsToValidate;
};
const $5a630f948a937af8$export$404e7e78d12e7892 = (styles)=>{
    return {
        // use defaults to fill in any missing fields
        ...(0, $6THkE.DEFAULT_STYLES),
        ...styles
    };
};
const $5a630f948a937af8$export$579466658e10543a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(51);
    const { localId: localId, editorActions: editorActions } = t0;
    let t1;
    if ($[0] !== editorActions || $[1] !== localId) {
        t1 = ()=>$5a630f948a937af8$var$fetchLocalIdMacroParameters(editorActions, localId);
        $[0] = editorActions;
        $[1] = localId;
        $[2] = t1;
    } else t1 = $[2];
    const [extensionParameters, setExtensionParameters] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[3] !== extensionParameters) {
        t2 = extensionParameters ?? {};
        $[3] = extensionParameters;
        $[4] = t2;
    } else t2 = $[4];
    const { items: items } = t2;
    let t3;
    let t4;
    if ($[5] !== editorActions || $[6] !== localId) {
        t3 = ()=>{
            const extensionNodeParams = $5a630f948a937af8$var$fetchLocalIdMacroParameters(editorActions, localId);
            setExtensionParameters(extensionNodeParams);
        };
        t4 = [
            editorActions,
            localId
        ];
        $[5] = editorActions;
        $[6] = localId;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== editorActions || $[10] !== extensionParameters) {
        t5 = (newExtensionParameters)=>{
            if (!extensionParameters) return;
            const updatedParams = {
                ...extensionParameters,
                ...newExtensionParameters
            };
            (0, $hiHdh.updateNodeParameters)(editorActions, updatedParams);
            setExtensionParameters(updatedParams);
        };
        $[9] = editorActions;
        $[10] = extensionParameters;
        $[11] = t5;
    } else t5 = $[11];
    const updateExtensionParams = t5;
    let t6;
    if ($[12] !== items || $[13] !== updateExtensionParams) {
        t6 = (item, parentId, position)=>{
            const clonedItems = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(items);
            const updatedItems = (0, $bcbc0d6f4b7dc8cf$export$133e0070ec60504c)($5a630f948a937af8$export$6c8e1d57a494d583(clonedItems), item, parentId, position);
            updateExtensionParams({
                items: updatedItems
            });
        };
        $[12] = items;
        $[13] = updateExtensionParams;
        $[14] = t6;
    } else t6 = $[14];
    const addItem = t6;
    let t7;
    if ($[15] !== items || $[16] !== updateExtensionParams) {
        t7 = (item_0, title, link)=>{
            const newItem = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(item_0);
            if (title) newItem.title = title;
            if (link) newItem.link = link;
            const clonedItems_0 = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(items);
            const updatedItems_0 = (0, $bcbc0d6f4b7dc8cf$export$2d1285fd35af5519)($5a630f948a937af8$export$6c8e1d57a494d583(clonedItems_0), newItem);
            updateExtensionParams({
                items: updatedItems_0
            });
        };
        $[15] = items;
        $[16] = updateExtensionParams;
        $[17] = t7;
    } else t7 = $[17];
    const updateItem = t7;
    let t8;
    if ($[18] !== items || $[19] !== updateExtensionParams) {
        t8 = (item_1, position_0, parentId_0)=>{
            const clonedItems_1 = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(items);
            const itemsWithoutOldEntry = (0, $bcbc0d6f4b7dc8cf$export$49f42e821420f72e)($5a630f948a937af8$export$6c8e1d57a494d583(clonedItems_1), item_1.itemId);
            const itemsWithNewEntry = (0, $bcbc0d6f4b7dc8cf$export$133e0070ec60504c)(itemsWithoutOldEntry, item_1, parentId_0, position_0);
            updateExtensionParams({
                items: itemsWithNewEntry
            });
        };
        $[18] = items;
        $[19] = updateExtensionParams;
        $[20] = t8;
    } else t8 = $[20];
    const moveItem = t8;
    let t9;
    if ($[21] !== items || $[22] !== updateExtensionParams) {
        t9 = (itemId)=>{
            const clonedItems_2 = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(items);
            const updatedItems_1 = (0, $bcbc0d6f4b7dc8cf$export$49f42e821420f72e)($5a630f948a937af8$export$6c8e1d57a494d583(clonedItems_2), itemId);
            updateExtensionParams({
                items: updatedItems_1
            });
        };
        $[21] = items;
        $[22] = updateExtensionParams;
        $[23] = t9;
    } else t9 = $[23];
    const deleteItem = t9;
    let t10;
    if ($[24] !== editorActions) {
        t10 = (updateField)=>(value)=>{
                setExtensionParameters((prevParams)=>{
                    if (!prevParams) return null;
                    const newParams = {
                        ...prevParams,
                        styles: {
                            ...$5a630f948a937af8$export$404e7e78d12e7892(prevParams.styles),
                            [updateField]: value
                        }
                    };
                    (0, $hiHdh.updateNodeParameters)(editorActions, newParams);
                    return newParams;
                });
            };
        $[24] = editorActions;
        $[25] = t10;
    } else t10 = $[25];
    const createStyleUpdater = t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    if ($[26] !== createStyleUpdater) {
        t11 = createStyleUpdater("alignment");
        t12 = createStyleUpdater("fillColor");
        t13 = createStyleUpdater("border");
        t14 = createStyleUpdater("cornerStyle");
        t15 = createStyleUpdater("cornerRadius");
        t16 = createStyleUpdater("borderColor");
        t17 = createStyleUpdater("textColor");
        t18 = createStyleUpdater("highlightColor");
        $[26] = createStyleUpdater;
        $[27] = t11;
        $[28] = t12;
        $[29] = t13;
        $[30] = t14;
        $[31] = t15;
        $[32] = t16;
        $[33] = t17;
        $[34] = t18;
    } else {
        t11 = $[27];
        t12 = $[28];
        t13 = $[29];
        t14 = $[30];
        t15 = $[31];
        t16 = $[32];
        t17 = $[33];
        t18 = $[34];
    }
    let t19;
    if ($[35] !== addItem || $[36] !== deleteItem || $[37] !== moveItem || $[38] !== t11 || $[39] !== t12 || $[40] !== t13 || $[41] !== t14 || $[42] !== t15 || $[43] !== t16 || $[44] !== t17 || $[45] !== t18 || $[46] !== updateItem) {
        t19 = {
            addItem: addItem,
            updateItem: updateItem,
            moveItem: moveItem,
            deleteItem: deleteItem,
            updateAlignment: t11,
            updateFillColor: t12,
            updateBorder: t13,
            updateCornerStyle: t14,
            updateCornerRadius: t15,
            updateBorderColor: t16,
            updateTextColor: t17,
            updateHighlightColor: t18
        };
        $[35] = addItem;
        $[36] = deleteItem;
        $[37] = moveItem;
        $[38] = t11;
        $[39] = t12;
        $[40] = t13;
        $[41] = t14;
        $[42] = t15;
        $[43] = t16;
        $[44] = t17;
        $[45] = t18;
        $[46] = updateItem;
        $[47] = t19;
    } else t19 = $[47];
    const extensionActions = t19;
    let t20;
    if ($[48] !== extensionActions || $[49] !== extensionParameters) {
        t20 = {
            extensionParameters: extensionParameters,
            extensionActions: extensionActions
        };
        $[48] = extensionActions;
        $[49] = extensionParameters;
        $[50] = t20;
    } else t20 = $[50];
    return t20;
} : ({ localId: localId, editorActions: editorActions })=>{
    const [extensionParameters, setExtensionParameters] = (0, $cozmU.useState)(()=>$5a630f948a937af8$var$fetchLocalIdMacroParameters(editorActions, localId));
    const { items: items } = extensionParameters ?? {};
    (0, $cozmU.useEffect)(()=>{
        const extensionNodeParams = $5a630f948a937af8$var$fetchLocalIdMacroParameters(editorActions, localId);
        setExtensionParameters(extensionNodeParams);
    }, [
        editorActions,
        localId
    ]);
    const updateExtensionParams = (0, $cozmU.useCallback)((newExtensionParameters)=>{
        if (!extensionParameters) return;
        const updatedParams = {
            ...extensionParameters,
            ...newExtensionParameters
        };
        // Save params to ADF and state
        (0, $hiHdh.updateNodeParameters)(editorActions, updatedParams);
        setExtensionParameters(updatedParams);
    }, [
        editorActions,
        extensionParameters
    ]);
    const addItem = (0, $cozmU.useCallback)((item, parentId, position)=>{
        const clonedItems = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(items);
        const updatedItems = (0, $bcbc0d6f4b7dc8cf$export$133e0070ec60504c)($5a630f948a937af8$export$6c8e1d57a494d583(clonedItems), item, parentId, position);
        updateExtensionParams({
            items: updatedItems
        });
    }, [
        items,
        updateExtensionParams
    ]);
    const updateItem = (0, $cozmU.useCallback)((item_0, title, link)=>{
        const newItem = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(item_0);
        if (title) newItem.title = title;
        if (link) newItem.link = link;
        const clonedItems_0 = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(items);
        const updatedItems_0 = (0, $bcbc0d6f4b7dc8cf$export$2d1285fd35af5519)($5a630f948a937af8$export$6c8e1d57a494d583(clonedItems_0), newItem);
        updateExtensionParams({
            items: updatedItems_0
        });
    }, [
        items,
        updateExtensionParams
    ]);
    const moveItem = (0, $cozmU.useCallback)((item_1, position_0, parentId_0)=>{
        const clonedItems_1 = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(items);
        const itemsWithoutOldEntry = (0, $bcbc0d6f4b7dc8cf$export$49f42e821420f72e)($5a630f948a937af8$export$6c8e1d57a494d583(clonedItems_1), item_1.itemId);
        const itemsWithNewEntry = (0, $bcbc0d6f4b7dc8cf$export$133e0070ec60504c)(itemsWithoutOldEntry, item_1, parentId_0, position_0);
        updateExtensionParams({
            items: itemsWithNewEntry
        });
    }, [
        items,
        updateExtensionParams
    ]);
    const deleteItem = (0, $cozmU.useCallback)((itemId)=>{
        const clonedItems_2 = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(items);
        const updatedItems_1 = (0, $bcbc0d6f4b7dc8cf$export$49f42e821420f72e)($5a630f948a937af8$export$6c8e1d57a494d583(clonedItems_2), itemId);
        updateExtensionParams({
            items: updatedItems_1
        });
    }, [
        items,
        updateExtensionParams
    ]);
    const createStyleUpdater = (0, $cozmU.useCallback)((updateField)=>(value)=>{
            setExtensionParameters((prevParams)=>{
                if (!prevParams) return null;
                const newParams = {
                    ...prevParams,
                    styles: {
                        ...$5a630f948a937af8$export$404e7e78d12e7892(prevParams.styles),
                        [updateField]: value
                    }
                };
                (0, $hiHdh.updateNodeParameters)(editorActions, newParams);
                return newParams;
            });
        }, [
        editorActions
    ]);
    const extensionActions = (0, $cozmU.useMemo)(()=>({
            addItem: addItem,
            updateItem: updateItem,
            moveItem: moveItem,
            deleteItem: deleteItem,
            updateAlignment: createStyleUpdater('alignment'),
            updateFillColor: createStyleUpdater('fillColor'),
            updateBorder: createStyleUpdater('border'),
            updateCornerStyle: createStyleUpdater('cornerStyle'),
            updateCornerRadius: createStyleUpdater('cornerRadius'),
            updateBorderColor: createStyleUpdater('borderColor'),
            updateTextColor: createStyleUpdater('textColor'),
            updateHighlightColor: createStyleUpdater('highlightColor')
        }), [
        addItem,
        updateItem,
        moveItem,
        deleteItem,
        createStyleUpdater
    ]);
    return {
        extensionParameters: extensionParameters,
        extensionActions: extensionActions
    };
};












var $kA6Zo = parcelRequire("kA6Zo");











var $hekY6 = parcelRequire("hekY6");





var $1zKNa = parcelRequire("1zKNa");


var $iSrRp = parcelRequire("iSrRp");











var $9kbTQ = parcelRequire("9kbTQ");


var $bB0i2 = parcelRequire("bB0i2");





var $fl787 = parcelRequire("fl787");


var $aDtKq = parcelRequire("aDtKq");





var $fYWmN = parcelRequire("fYWmN");


var $cDMxg = parcelRequire("cDMxg");










const $c5b5e7c02851da02$var$draggingStyles = (0, $buxP3.xcss)({
    opacity: 0.5
});
const $c5b5e7c02851da02$var$wrapperStyles = (0, $buxP3.xcss)({
    position: 'relative',
    cursor: 'grab'
});
const $c5b5e7c02851da02$var$previewStyles = (0, $buxP3.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface.overlay',
    maxWidth: '360px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $c5b5e7c02851da02$export$588e2663e0be32a3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { children: children, item: item, isDragging: isDragging, setIsDragging: setIsDragging, index: index, parentId: parentId, level: level } = t0;
    const ref = (0, $cozmU.useRef)(null);
    const [dropIndicatorInstruction, setDropIndicatorInstruction] = (0, $cozmU.useState)();
    const [previewContainer, setPreviewContainer] = (0, $cozmU.useState)();
    let t1;
    let t2;
    if ($[0] !== index || $[1] !== item || $[2] !== level || $[3] !== parentId || $[4] !== setIsDragging) {
        t1 = ()=>{
            const el = ref.current;
            (0, $bB0i2.default)(el);
            return (0, $aDtKq.combine)((0, $iSrRp.draggable)({
                element: el,
                onDragStart: ()=>setIsDragging(true),
                onDrop: ()=>setIsDragging(false),
                getInitialData: ()=>({
                        id: item.itemId,
                        parentId: parentId,
                        index: index,
                        type: item.type,
                        item: item
                    }),
                onGenerateDragPreview: (t3)=>{
                    const { nativeSetDragImage: nativeSetDragImage } = t3;
                    (0, $cDMxg.setCustomNativeDragPreview)({
                        nativeSetDragImage: nativeSetDragImage,
                        getOffset: (0, $fYWmN.pointerOutsideOfPreview)({
                            x: "var(--ds-space-200, 16px)",
                            y: "var(--ds-space-100, 8px)"
                        }),
                        render: (t4)=>{
                            const { container: container } = t4;
                            setPreviewContainer(container);
                        }
                    });
                }
            }), (0, $iSrRp.dropTargetForElements)({
                element: el,
                canDrop: ()=>{
                    if (level > (0, $5a630f948a937af8$export$3fcb5b76d26bf473)() + 1) return false;
                    return true;
                },
                onDragLeave: ()=>{
                    setDropIndicatorInstruction(null);
                    setPreviewContainer(null);
                },
                onDrop: ()=>{
                    setDropIndicatorInstruction(null);
                    setPreviewContainer(null);
                },
                onDrag: (t5)=>{
                    const { self: self, source: source } = t5;
                    const instruction = (0, $1zKNa.extractInstruction)(self.data);
                    if (source.data.id === item.itemId || instruction?.type === "instruction-blocked") setDropIndicatorInstruction(null);
                    else setDropIndicatorInstruction(instruction);
                },
                getData: (t6)=>{
                    const { input: input, element: element } = t6;
                    const data = {
                        id: item.itemId,
                        parentId: parentId,
                        index: index,
                        type: item.type,
                        item: item
                    };
                    let blockInstructions = [
                        "make-child"
                    ];
                    if (item.type === (0, $8Yw12.ITEM).MENU) {
                        blockInstructions = [];
                        if (item.childItems?.length) blockInstructions.push("reorder-below");
                        if (level > (0, $5a630f948a937af8$export$3fcb5b76d26bf473)()) blockInstructions.push("make-child");
                    }
                    return (0, $1zKNa.attachInstruction)(data, {
                        input: input,
                        element: element,
                        currentLevel: level,
                        indentPerLevel: 0,
                        mode: "standard",
                        block: blockInstructions
                    });
                }
            }));
        };
        t2 = [
            item,
            setIsDragging,
            parentId,
            index,
            setDropIndicatorInstruction,
            level
        ];
        $[0] = index;
        $[1] = item;
        $[2] = level;
        $[3] = parentId;
        $[4] = setIsDragging;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const t3 = isDragging && $c5b5e7c02851da02$var$draggingStyles;
    let t4;
    if ($[7] !== t3) {
        t4 = [
            t3,
            $c5b5e7c02851da02$var$wrapperStyles
        ];
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    const t5 = `draggable-links-menu-item-${item.itemId}`;
    let t6;
    if ($[9] !== dropIndicatorInstruction) {
        t6 = dropIndicatorInstruction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fl787.DropIndicator), {
            instruction: dropIndicatorInstruction
        }) : null;
        $[9] = dropIndicatorInstruction;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== children || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            ref: ref,
            xcss: t4,
            testId: t5
        }, children, t6);
        $[11] = children;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== item.title || $[17] !== previewContainer) {
        t8 = previewContainer && /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $c5b5e7c02851da02$var$previewStyles
        }, item.title), previewContainer);
        $[16] = item.title;
        $[17] = previewContainer;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== t7 || $[20] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t7, t8);
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
} : ({ children: children, item: item, isDragging: isDragging, setIsDragging: setIsDragging, index: index, parentId: parentId, level: level })=>{
    const ref = (0, $cozmU.useRef)(null);
    const [dropIndicatorInstruction, setDropIndicatorInstruction] = (0, $cozmU.useState)();
    const [previewContainer, setPreviewContainer] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        const el = ref.current;
        (0, $bB0i2.default)(el);
        return (0, $aDtKq.combine)((0, $iSrRp.draggable)({
            element: el,
            onDragStart: ()=>setIsDragging(true),
            onDrop: ()=>setIsDragging(false),
            getInitialData: ()=>{
                return {
                    id: item.itemId,
                    parentId: parentId,
                    index: index,
                    type: item.type,
                    item: item
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $cDMxg.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $fYWmN.pointerOutsideOfPreview)({
                        x: "var(--ds-space-200, 16px)",
                        y: "var(--ds-space-100, 8px)"
                    }),
                    render: ({ container: container })=>{
                        setPreviewContainer(container);
                    }
                });
            }
        }), (0, $iSrRp.dropTargetForElements)({
            element: el,
            canDrop: ()=>{
                // Stop user from dragging & dropping into deep nesting.
                // It's possible for users to work around our guardrails here and
                // and nest more levels than we "allow," by dragging and dropping already
                // deeply-nested trees into another deep nested target - as long as
                // the target element isn't exceeding the max level.
                // User will only be halted by some restrictions on the item creation buttons
                // and cursory checks like the ones below.
                // These guardrails are in place to 1. help admins make their content
                // accessible / well designed and 2. enforce scale limits.
                // With 1, we can let a user choose to work around that purposely, but they
                // still won't be able to get around our harder item number limit (see
                // MAXIMUM_ITEM_LIMIT) unless they directly query backend with an ADF update,
                // so 2 is not really a concern either.
                if (level > (0, $5a630f948a937af8$export$3fcb5b76d26bf473)() + 1) return false;
                return true;
            },
            onDragLeave: ()=>{
                setDropIndicatorInstruction(null);
                setPreviewContainer(null);
            },
            onDrop: ()=>{
                setDropIndicatorInstruction(null);
                setPreviewContainer(null);
            },
            onDrag: ({ self: self, source: source })=>{
                const instruction = (0, $1zKNa.extractInstruction)(self.data);
                if (source.data.id === item.itemId || instruction?.type === 'instruction-blocked') setDropIndicatorInstruction(null);
                else setDropIndicatorInstruction(instruction);
            },
            getData: ({ input: input, element: element })=>{
                const data = {
                    id: item.itemId,
                    parentId: parentId,
                    index: index,
                    type: item.type,
                    item: item
                };
                // only menu items can be parents, so block make-child for links
                let blockInstructions = [
                    'make-child'
                ];
                if (item.type === (0, $8Yw12.ITEM).MENU) {
                    blockInstructions = [];
                    // Don't let user reorder-below a menu item that has children,
                    // because the drop indicator shows up under the menu item and
                    // doesn't visually represent the end state (current item will
                    // reorder *after* the menu *plus* all its children).
                    // User will still be able to achieve their desired goal by
                    // reordering above the subsequent item on the same level as
                    // this menu item.
                    // Exception is if this menu item is last in the list. In that case,
                    // they'll need to use a workaround for now by dragging the menu item
                    // upwards instead. @TODO, fix this papercut.
                    if (item.childItems?.length) blockInstructions.push('reorder-below');
                    if (level > (0, $5a630f948a937af8$export$3fcb5b76d26bf473)()) blockInstructions.push('make-child');
                }
                return (0, $1zKNa.attachInstruction)(data, {
                    input: input,
                    element: element,
                    currentLevel: level,
                    indentPerLevel: 0,
                    mode: 'standard',
                    block: blockInstructions
                });
            }
        }));
    }, [
        item,
        setIsDragging,
        parentId,
        index,
        setDropIndicatorInstruction,
        level
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        ref: ref,
        xcss: [
            isDragging && $c5b5e7c02851da02$var$draggingStyles,
            $c5b5e7c02851da02$var$wrapperStyles
        ],
        testId: `draggable-links-menu-item-${item.itemId}`
    }, children, dropIndicatorInstruction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fl787.DropIndicator), {
        instruction: dropIndicatorInstruction
    }) : null), previewContainer && /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $c5b5e7c02851da02$var$previewStyles
    }, item.title), previewContainer));
};















var $1sCHt = parcelRequire("1sCHt");


var $6TaGl = parcelRequire("6TaGl");


var $5wHqn = parcelRequire("5wHqn");















var $iOZNd = parcelRequire("iOZNd");


var $hMaHH = parcelRequire("hMaHH");


var $cJ0FD = parcelRequire("cJ0FD");


var $4yccB = parcelRequire("4yccB");

const $f289f531ad1c09f8$export$17270ac458723b0f = async (link, submitError)=>{
    try {
        const client = new (0, $4yccB.default)();
        const resolvedLinkData = (await client.fetchData(link)).data || {};
        const isInternalResource = resolvedLinkData['atlassian:ari'];
        const externalIconUrl = resolvedLinkData.icon?.url;
        if (!isInternalResource && externalIconUrl) return externalIconUrl;
    } catch (error) {
        submitError?.(error);
    }
    return undefined;
};







const $57fd414daf32f352$export$f508444e7933c2b1 = ({ item: item })=>{
    const [externalIconUrl, setExternalIconUrl] = (0, $cozmU.useState)('');
    const link = item.type === (0, $8Yw12.ITEM).LINK ? item.link : '';
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    (0, $cozmU.useEffect)(()=>{
        const fetchIconComponent = async ()=>{
            if (link) {
                const url = await (0, $f289f531ad1c09f8$export$17270ac458723b0f)(link, submitError);
                if (url) setExternalIconUrl(url);
            }
        };
        fetchIconComponent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        link
    ]);
    if (externalIconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: externalIconUrl,
        height: 16,
        width: 16,
        alt: ""
    });
    if (item.type === (0, $8Yw12.ITEM).LINK) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
        label: ""
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iOZNd))), {
        label: ""
    });
};









var $9DHhW = parcelRequire("9DHhW");


var $ad7Ou = parcelRequire("ad7Ou");


var $fuSOM = parcelRequire("fuSOM");










var $8pCvZ = parcelRequire("8pCvZ");


var $bQmwQ = parcelRequire("bQmwQ");


















var $7BfeF = parcelRequire("7BfeF");

var $kB5K2 = parcelRequire("kB5K2");







var $4yg9g = parcelRequire("4yg9g");




const $f50c67b7888f402c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    displayTextLabel: {
        id: "company-hub.links-menu-extension.config-panel.property-config.display-text-label",
        defaultMessage: "Display text"
    },
    displayTextPlaceholder: {
        id: "company-hub.links-menu-extension.config-panel.property-config.display-text-placeholder",
        defaultMessage: "Item name"
    },
    displayTextError: {
        id: "company-hub.links-menu-extension.config-panel.property-config.display-text-error",
        defaultMessage: "Please fill out this field."
    }
});


const $103779f45dadb877$var$errorStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.050',
    gap: 'space.050',
    height: '16px'
});
const $103779f45dadb877$export$4a8624fe9f1d9d1e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { itemId: itemId, displayText: displayText, handleOnChange: handleOnChange, isInvalid: isInvalid } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $f50c67b7888f402c$export$defe85febe8b728c).displayTextLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== itemId || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: itemId
        }, t1);
        $[2] = itemId;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== formatMessage) {
        t3 = formatMessage((0, $f50c67b7888f402c$export$defe85febe8b728c).displayTextPlaceholder);
        $[5] = formatMessage;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== displayText || $[8] !== handleOnChange || $[9] !== isInvalid || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            value: displayText,
            onChange: handleOnChange,
            placeholder: t3,
            isInvalid: isInvalid,
            maxLength: 100
        });
        $[7] = displayText;
        $[8] = handleOnChange;
        $[9] = isInvalid;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== isInvalid) {
        t5 = isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $103779f45dadb877$var$errorStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $f50c67b7888f402c$export$defe85febe8b728c).displayTextError)));
        $[12] = isInvalid;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t2 || $[15] !== t4 || $[16] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, t4, t5);
        $[14] = t2;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : ({ itemId: itemId, displayText: displayText, handleOnChange: handleOnChange, isInvalid: isInvalid })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: itemId
    }, formatMessage((0, $f50c67b7888f402c$export$defe85febe8b728c).displayTextLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        value: displayText,
        onChange: handleOnChange,
        placeholder: formatMessage((0, $f50c67b7888f402c$export$defe85febe8b728c).displayTextPlaceholder),
        isInvalid: isInvalid,
        // link picker will still be able to insert a title longer than this
        // and there's no error messaging, but user will stop being able to
        // input more text after 100 chars
        maxLength: 100
    }), isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $103779f45dadb877$var$errorStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $f50c67b7888f402c$export$defe85febe8b728c).displayTextError))));
};





const $139899a4cdcd8470$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    cancelButtonLabel: {
        id: "company-hub.links-menu-extension.config-panel.property-config.cancel-button-label",
        defaultMessage: "Cancel"
    },
    confirmButtonLabel: {
        id: "company-hub.links-menu-extension.config-panel.property-config.confirm-button-label",
        defaultMessage: "Confirm"
    }
});


const $66131ca3daf51fef$var$configStyles = (0, $buxP3.xcss)({
    margin: 'space.200',
    width: '310px'
});
const $66131ca3daf51fef$var$buttonStyles = (0, $buxP3.xcss)({
    marginTop: 'space.200',
    justifyContent: 'flex-end',
    gap: 'space.050'
});
const $66131ca3daf51fef$var$linkPickerCustomMessages = (0, $kSwu1.defineMessages)({
    submitButtonLabel: {
        id: "company-hub.links-menu-extension.config-panel.property-config.link.submit-button-label",
        defaultMessage: "Confirm"
    }
});
const $66131ca3daf51fef$var$supportedPluginKeys = [
    'confluence',
    'jira',
    'atlas',
    'loom'
];
const $66131ca3daf51fef$export$7aec99e1cacc0106 = ({ extensionActions: extensionActions, handleClose: handleClose, existingItem: existingItem, newItemType: newItemType, parentId: parentId, update: update })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { addItem: addItem, updateItem: updateItem } = extensionActions;
    const { cloudId: cloudId, linkPickerConfig: linkPickerConfig } = (0, $cfM7x.useProductDependencies)();
    // If create new type is passed in, create a new item with default parameters
    const [item] = (0, $cozmU.useState)(()=>{
        if (newItemType === (0, $8Yw12.ITEM).LINK) return (0, $5a630f948a937af8$export$42f5e9ab021856ba)();
        else if (newItemType === (0, $8Yw12.ITEM).MENU) return (0, $5a630f948a937af8$export$8623c79a5744076b)();
        else return existingItem;
    });
    const [textFieldValue, setTextFieldValue] = (0, $cozmU.useState)(item.title);
    const [isError, setIsError] = (0, $cozmU.useState)(false);
    const handleTextFieldChange = (0, $cozmU.useCallback)((event)=>{
        const { value: value } = event.target;
        setTextFieldValue(value);
        setIsError(false);
    }, []);
    // used for link item, extra step to handle link field
    const handleSubmitForLink = (payload)=>{
        // The link picker automatically submits when users select a
        // suggested link from the results, even if they have not
        // specified a title yet or hit Confirm. Here we interrupt
        // auto submission and set the display text to the link's title,
        // if none exists and we have a title from linking platform.
        // Then, when users hit Confirm manually the submission will happen.
        if (textFieldValue.length === 0 && payload.title) // If we have a page title from the link picker then set
        // empty display text to that value
        setTextFieldValue(payload.title);
        else // submit the update with link field
        handleSubmit(payload.url);
    };
    const handleSubmit = (link)=>{
        // do validation for display text field
        if (textFieldValue.length === 0) {
            setIsError(true);
            return;
        }
        // add item if new
        if (!!newItemType) {
            // set properties on new item
            item.title = textFieldValue;
            if (link) item.link = link;
            addItem(item, parentId);
        } else updateItem(item, textFieldValue, link);
        createAnalyticsEvent?.({
            type: 'sendTrackEvent',
            data: {
                action: !!newItemType ? 'added' : 'updated',
                actionSubject: 'item',
                source: (0, $bQmwQ.LINKS_MENU_EXTENSION_ANALYTIC_SOURCE),
                attributes: {
                    itemType: item.link ? 'link' : 'menu'
                }
            }
        }).fire();
        handleClose();
    };
    const { isLoading: isLoading, plugins: plugins } = (0, $8pCvZ.useLinkPickerPlugins)({
        cloudId: cloudId,
        product: 'confluence'
    });
    const filteredPlugins = (0, $cozmU.useMemo)(()=>{
        return plugins.filter((plugin)=>{
            return plugin.tabKey && $66131ca3daf51fef$var$supportedPluginKeys.includes(plugin.tabKey);
        });
    }, [
        plugins
    ]);
    // Use custom plugins if provided, otherwise use default filtered plugins
    const pluginsToUse = linkPickerConfig?.linkPickerPlugins || filteredPlugins;
    const isLoadingPlugins = linkPickerConfig?.linkPickerPlugins ? false : isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $66131ca3daf51fef$var$configStyles,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $103779f45dadb877$export$4a8624fe9f1d9d1e), {
        itemId: item.itemId,
        displayText: textFieldValue,
        handleOnChange: handleTextFieldChange,
        isInvalid: isError
    }), item.type === (0, $8Yw12.ITEM).LINK ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fuSOM.default), {
        plugins: pluginsToUse,
        isLoadingPlugins: isLoadingPlugins,
        url: item.link,
        displayText: item.title,
        onSubmit: handleSubmitForLink,
        onCancel: handleClose,
        hideDisplayText: true,
        paddingLeft: "0px",
        paddingRight: "0px",
        paddingBottom: "0px",
        disableWidth: true,
        customMessages: $66131ca3daf51fef$var$linkPickerCustomMessages,
        onContentResize: update
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $66131ca3daf51fef$var$buttonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleClose
    }, formatMessage((0, $139899a4cdcd8470$export$defe85febe8b728c).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: ()=>handleSubmit()
    }, formatMessage((0, $139899a4cdcd8470$export$defe85febe8b728c).confirmButtonLabel))));
};















var $aRvnq = parcelRequire("aRvnq");


var $9d7Pd = parcelRequire("9d7Pd");

var $8oBbn = parcelRequire("8oBbn");





var $lpNn5 = parcelRequire("lpNn5");





















var $kTb7m = parcelRequire("kTb7m");




var $6IL1T = parcelRequire("6IL1T");















const $6e3cca665228d1d0$var$message = (0, $kSwu1.defineMessages)({
    addLinkButtonText: {
        id: "company-hub.links-menu-extension.config-panel.add-link-button.text",
        defaultMessage: "Link"
    },
    addLinkButtonDescription: {
        id: "company-hub.links-menu-extension.config-panel.add-link-button.description",
        defaultMessage: "Add important links"
    },
    addMenuButtonText: {
        id: "company-hub.links-menu-extension.config-panel.add-menu-button.text",
        defaultMessage: "Menu"
    },
    addMenuButtonDescription: {
        id: "company-hub.links-menu-extension.config-panel.add-menu-button.description",
        defaultMessage: "Group related links together"
    },
    menuSubItemCreationDisabledTooltipText: {
        id: "company-hub.links-menu-extension.config-panel.add-menu-button.disabled.tooltip-text",
        defaultMessage: "You have reached the maximum number of nested levels."
    }
});
var $6e3cca665228d1d0$export$2e2bcd8739ae039 = $6e3cca665228d1d0$var$message;


const $6a07483b640d0b00$var$menuGroupStyles = (0, $buxP3.xcss)({
    width: '300px'
});
const $6a07483b640d0b00$export$92ef8f592bb35119 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { setIsConfiguring: setIsConfiguring, setNewItemType: setNewItemType, isAddMenuSubItemDisabled: t1 } = t0;
    const isAddMenuSubItemDisabled = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== setIsConfiguring || $[1] !== setNewItemType) {
        t2 = ()=>{
            setIsConfiguring(true);
            setNewItemType((0, $8Yw12.ITEM).LINK);
        };
        $[0] = setIsConfiguring;
        $[1] = setNewItemType;
        $[2] = t2;
    } else t2 = $[2];
    const handleAddLinkClick = t2;
    let t3;
    if ($[3] !== setIsConfiguring || $[4] !== setNewItemType) {
        t3 = ()=>{
            setIsConfiguring(true);
            setNewItemType((0, $8Yw12.ITEM).MENU);
        };
        $[3] = setIsConfiguring;
        $[4] = setNewItemType;
        $[5] = t3;
    } else t3 = $[5];
    const handleAddMenuClick = t3;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: ""
        });
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== intl) {
        t5 = intl.formatMessage((0, $6e3cca665228d1d0$export$2e2bcd8739ae039).addLinkButtonDescription);
        $[7] = intl;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6e3cca665228d1d0$export$2e2bcd8739ae039).addLinkButtonText);
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== handleAddLinkClick || $[11] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            iconBefore: t4,
            description: t5,
            onClick: handleAddLinkClick
        }, t6);
        $[10] = handleAddLinkClick;
        $[11] = t5;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6e3cca665228d1d0$export$2e2bcd8739ae039).menuSubItemCreationDisabledTooltipText);
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== isAddMenuSubItemDisabled) {
        t9 = ()=>isAddMenuSubItemDisabled;
        $[14] = isAddMenuSubItemDisabled;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iOZNd))), {
            label: ""
        });
        $[16] = t10;
    } else t10 = $[16];
    let t11;
    if ($[17] !== intl) {
        t11 = intl.formatMessage((0, $6e3cca665228d1d0$export$2e2bcd8739ae039).addMenuButtonDescription);
        $[17] = intl;
        $[18] = t11;
    } else t11 = $[18];
    let t12;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6e3cca665228d1d0$export$2e2bcd8739ae039).addMenuButtonText);
        $[19] = t12;
    } else t12 = $[19];
    let t13;
    if ($[20] !== handleAddMenuClick || $[21] !== isAddMenuSubItemDisabled || $[22] !== t11) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            isDisabled: isAddMenuSubItemDisabled,
            iconBefore: t10,
            description: t11,
            onClick: handleAddMenuClick
        }, t12);
        $[20] = handleAddMenuClick;
        $[21] = isAddMenuSubItemDisabled;
        $[22] = t11;
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== t13 || $[25] !== t9) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t8,
            canAppear: t9
        }, t13);
        $[24] = t13;
        $[25] = t9;
        $[26] = t14;
    } else t14 = $[26];
    let t15;
    if ($[27] !== t14 || $[28] !== t7) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $6a07483b640d0b00$var$menuGroupStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
            minWidth: "100%"
        }, t7, t14));
        $[27] = t14;
        $[28] = t7;
        $[29] = t15;
    } else t15 = $[29];
    return t15;
} : ({ setIsConfiguring: setIsConfiguring, setNewItemType: setNewItemType, isAddMenuSubItemDisabled: isAddMenuSubItemDisabled = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const handleAddLinkClick = ()=>{
        setIsConfiguring(true);
        setNewItemType((0, $8Yw12.ITEM).LINK);
    };
    const handleAddMenuClick = ()=>{
        setIsConfiguring(true);
        setNewItemType((0, $8Yw12.ITEM).MENU);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $6a07483b640d0b00$var$menuGroupStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
        minWidth: "100%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: ""
        }),
        description: intl.formatMessage((0, $6e3cca665228d1d0$export$2e2bcd8739ae039).addLinkButtonDescription),
        onClick: handleAddLinkClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6e3cca665228d1d0$export$2e2bcd8739ae039).addLinkButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6e3cca665228d1d0$export$2e2bcd8739ae039).menuSubItemCreationDisabledTooltipText),
        canAppear: ()=>isAddMenuSubItemDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        isDisabled: isAddMenuSubItemDisabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iOZNd))), {
            label: ""
        }),
        description: intl.formatMessage((0, $6e3cca665228d1d0$export$2e2bcd8739ae039).addMenuButtonDescription),
        onClick: handleAddMenuClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6e3cca665228d1d0$export$2e2bcd8739ae039).addMenuButtonText)))));
};
























var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");

var $aRGok = parcelRequire("aRGok");


var $4aRua = parcelRequire("4aRua");










const $9d6362d76aaa3db1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    invokeDeleteButtonText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.delete-item-button.text",
        defaultMessage: "Delete item"
    },
    modalHeaderText: {
        id: "company-hub.links-menu-extension.config-panel.delete-nested-items-modal.title-text",
        defaultMessage: "Delete item"
    },
    modalDescriptionText: {
        id: "company-hub.links-menu-extension.config-panel.delete-nested-items-modal.description-text",
        defaultMessage: "This action will delete this item and all nested items."
    },
    confirmDeleteButtonText: {
        id: "company-hub.links-menu-extension.config-panel.delete-nested-items-modal.confirm-text",
        defaultMessage: "Delete"
    },
    cancelDeleteButtonText: {
        id: "company-hub.links-menu-extension.config-panel.delete-nested-items-modal.cancel-text",
        defaultMessage: "Cancel"
    }
});


const $4d8213e10e6bbe53$export$9ed99085725e367e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { item: item, extensionActions: extensionActions } = t0;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setIsOpen(true);
        $[0] = t1;
    } else t1 = $[0];
    const openModal = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsOpen(false);
        $[1] = t2;
    } else t2 = $[1];
    const closeModal = t2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { deleteItem: deleteItem } = extensionActions;
    let handleConfirmDelete;
    let handleDeleteClick;
    if ($[2] !== createAnalyticsEvent || $[3] !== deleteItem || $[4] !== item) {
        handleDeleteClick = ()=>{
            if (item.type === (0, $8Yw12.ITEM).MENU && item.childItems?.length) openModal();
            else handleConfirmDelete();
        };
        handleConfirmDelete = ()=>{
            createAnalyticsEvent?.({
                type: "sendTrackEvent",
                data: {
                    action: "deleted",
                    actionSubject: "item",
                    source: (0, $bQmwQ.LINKS_MENU_EXTENSION_ANALYTIC_SOURCE),
                    attributes: {
                        itemType: item.link ? "link" : "menu"
                    }
                }
            }).fire();
            deleteItem(item.itemId);
        };
        $[2] = createAnalyticsEvent;
        $[3] = deleteItem;
        $[4] = item;
        $[5] = handleConfirmDelete;
        $[6] = handleDeleteClick;
    } else {
        handleConfirmDelete = $[5];
        handleDeleteClick = $[6];
    }
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9d6362d76aaa3db1$export$defe85febe8b728c).invokeDeleteButtonText);
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== handleDeleteClick) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            onClick: handleDeleteClick
        }, t3);
        $[8] = handleDeleteClick;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== handleConfirmDelete || $[11] !== isOpen) {
        t5 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
            onClose: closeModal
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
            appearance: "warning"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9d6362d76aaa3db1$export$defe85febe8b728c).modalHeaderText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9d6362d76aaa3db1$export$defe85febe8b728c).modalDescriptionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: closeModal
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9d6362d76aaa3db1$export$defe85febe8b728c).cancelDeleteButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "warning",
            onClick: handleConfirmDelete
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9d6362d76aaa3db1$export$defe85febe8b728c).confirmDeleteButtonText))));
        $[10] = handleConfirmDelete;
        $[11] = isOpen;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, t5);
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t4 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t6);
        $[15] = t4;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : ({ item: item, extensionActions: extensionActions })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const openModal = ()=>setIsOpen(true);
    const closeModal = ()=>setIsOpen(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { deleteItem: deleteItem } = extensionActions;
    const handleDeleteClick = ()=>{
        if (item.type === (0, $8Yw12.ITEM).MENU && item.childItems?.length) openModal();
        else handleConfirmDelete();
    };
    const handleConfirmDelete = ()=>{
        createAnalyticsEvent?.({
            type: 'sendTrackEvent',
            data: {
                action: 'deleted',
                actionSubject: 'item',
                source: (0, $bQmwQ.LINKS_MENU_EXTENSION_ANALYTIC_SOURCE),
                attributes: {
                    itemType: item.link ? 'link' : 'menu'
                }
            }
        }).fire();
        deleteItem(item.itemId);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        onClick: handleDeleteClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9d6362d76aaa3db1$export$defe85febe8b728c).invokeDeleteButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: closeModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9d6362d76aaa3db1$export$defe85febe8b728c).modalHeaderText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9d6362d76aaa3db1$export$defe85febe8b728c).modalDescriptionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: closeModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9d6362d76aaa3db1$export$defe85febe8b728c).cancelDeleteButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "warning",
        onClick: handleConfirmDelete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9d6362d76aaa3db1$export$defe85febe8b728c).confirmDeleteButtonText))))));
};





const $6b7c00b7c19455fc$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    openLinkButtonText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.open-link-button.text",
        defaultMessage: "Open the link"
    },
    editPropertiesButtonText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.edit-properties-button.text",
        defaultMessage: "Edit properties"
    },
    addSubItemButtonText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.add-sub-item-button.text",
        defaultMessage: "Add sub item"
    },
    moveItemUpText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.move-item-up.text",
        defaultMessage: "Move up"
    },
    moveItemDownText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.move-item-down.text",
        defaultMessage: "Move down"
    },
    itemCreationDisabledTooltipText: {
        id: "company-hub.links-menu-extension.config-panel.sub-item-button.disabled.tooltip-text",
        defaultMessage: "You have reached the maximum number of items that can be added to a links menu."
    }
});


const $87fb9051120c4608$export$4837f2e6e199256e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(50);
    const { extensionActions: extensionActions, index: index, isFirst: isFirst, isLast: isLast, item: item, parentId: parentId, level: level, numberItems: numberItems, setIsPopupOpen: setIsPopupOpen, setIsConfiguring: setIsConfiguring, setNewItemType: setNewItemType } = t0;
    const { moveItem: moveItem } = extensionActions;
    const [isNestedPopupOpen, setIsNestedPopupOpen] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== setIsPopupOpen) {
        t1 = ()=>{
            setIsPopupOpen(false);
        };
        $[0] = setIsPopupOpen;
        $[1] = t1;
    } else t1 = $[1];
    const handleOpenLinkClick = t1;
    let t2;
    if ($[2] !== setIsConfiguring || $[3] !== setNewItemType) {
        t2 = ()=>{
            setIsConfiguring(true);
            setNewItemType(undefined);
        };
        $[2] = setIsConfiguring;
        $[3] = setNewItemType;
        $[4] = t2;
    } else t2 = $[4];
    const handleEditPropertiesClick = t2;
    let t3;
    if ($[5] !== index || $[6] !== item || $[7] !== moveItem || $[8] !== parentId || $[9] !== setIsPopupOpen) {
        t3 = ()=>{
            moveItem(item, index - 1, parentId);
            setIsPopupOpen(false);
        };
        $[5] = index;
        $[6] = item;
        $[7] = moveItem;
        $[8] = parentId;
        $[9] = setIsPopupOpen;
        $[10] = t3;
    } else t3 = $[10];
    const handleMoveUpClick = t3;
    let t4;
    if ($[11] !== index || $[12] !== item || $[13] !== moveItem || $[14] !== parentId || $[15] !== setIsPopupOpen) {
        t4 = ()=>{
            moveItem(item, index + 1, parentId);
            setIsPopupOpen(false);
        };
        $[11] = index;
        $[12] = item;
        $[13] = moveItem;
        $[14] = parentId;
        $[15] = setIsPopupOpen;
        $[16] = t4;
    } else t4 = $[16];
    const handleMoveDownClick = t4;
    let t5;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>setIsNestedPopupOpen(false);
        $[17] = t5;
    } else t5 = $[17];
    const handleSubItemPopupClose = t5;
    const reachedMaximumNestingLevel = level >= (0, $5a630f948a937af8$export$3fcb5b76d26bf473)();
    const reachedMaximumItems = numberItems >= (0, $5a630f948a937af8$export$8555315c03db9dc2)();
    let t6;
    if ($[18] !== handleOpenLinkClick || $[19] !== item.link || $[20] !== item.type) {
        t6 = item.type === (0, $8Yw12.ITEM).LINK && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
            href: item.link,
            target: "_blank",
            onClick: handleOpenLinkClick,
            isDisabled: !item.link
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).openLinkButtonText));
        $[18] = handleOpenLinkClick;
        $[19] = item.link;
        $[20] = item.type;
        $[21] = t6;
    } else t6 = $[21];
    let t7;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).editPropertiesButtonText);
        $[22] = t7;
    } else t7 = $[22];
    let t8;
    if ($[23] !== handleEditPropertiesClick) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            onClick: handleEditPropertiesClick
        }, t7);
        $[23] = handleEditPropertiesClick;
        $[24] = t8;
    } else t8 = $[24];
    let t9;
    if ($[25] !== isNestedPopupOpen || $[26] !== item.type || $[27] !== reachedMaximumItems || $[28] !== reachedMaximumNestingLevel || $[29] !== setIsConfiguring || $[30] !== setNewItemType) {
        t9 = item.type === (0, $8Yw12.ITEM).MENU && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).itemCreationDisabledTooltipText),
            canAppear: ()=>reachedMaximumItems
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            isOpen: isNestedPopupOpen,
            placement: "auto",
            onClose: handleSubItemPopupClose,
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a07483b640d0b00$export$92ef8f592bb35119), {
                    isAddMenuSubItemDisabled: reachedMaximumNestingLevel,
                    setIsConfiguring: setIsConfiguring,
                    setNewItemType: setNewItemType
                }),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    ...triggerProps,
                    isDisabled: reachedMaximumItems,
                    isSelected: isNestedPopupOpen,
                    onClick: ()=>setIsNestedPopupOpen(true),
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
                        label: "Add sub item"
                    })
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).addSubItemButtonText))
        }));
        $[25] = isNestedPopupOpen;
        $[26] = item.type;
        $[27] = reachedMaximumItems;
        $[28] = reachedMaximumNestingLevel;
        $[29] = setIsConfiguring;
        $[30] = setNewItemType;
        $[31] = t9;
    } else t9 = $[31];
    let t10;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).moveItemUpText);
        $[32] = t10;
    } else t10 = $[32];
    let t11;
    if ($[33] !== handleMoveUpClick || $[34] !== isFirst) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            isDisabled: isFirst,
            onClick: handleMoveUpClick
        }, t10);
        $[33] = handleMoveUpClick;
        $[34] = isFirst;
        $[35] = t11;
    } else t11 = $[35];
    let t12;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).moveItemDownText);
        $[36] = t12;
    } else t12 = $[36];
    let t13;
    if ($[37] !== handleMoveDownClick || $[38] !== isLast) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            isDisabled: isLast,
            onClick: handleMoveDownClick
        }, t12);
        $[37] = handleMoveDownClick;
        $[38] = isLast;
        $[39] = t13;
    } else t13 = $[39];
    let t14;
    if ($[40] !== extensionActions || $[41] !== item) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d8213e10e6bbe53$export$9ed99085725e367e), {
            item: item,
            extensionActions: extensionActions
        });
        $[40] = extensionActions;
        $[41] = item;
        $[42] = t14;
    } else t14 = $[42];
    let t15;
    if ($[43] !== t11 || $[44] !== t13 || $[45] !== t14 || $[46] !== t6 || $[47] !== t8 || $[48] !== t9) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t6, t8, t9, t11, t13, t14);
        $[43] = t11;
        $[44] = t13;
        $[45] = t14;
        $[46] = t6;
        $[47] = t8;
        $[48] = t9;
        $[49] = t15;
    } else t15 = $[49];
    return t15;
} : ({ extensionActions: extensionActions, index: index, isFirst: isFirst, isLast: isLast, item: item, parentId: parentId, level: level, numberItems: numberItems, setIsPopupOpen: setIsPopupOpen, setIsConfiguring: setIsConfiguring, setNewItemType: setNewItemType })=>{
    const { moveItem: moveItem } = extensionActions;
    const [isNestedPopupOpen, setIsNestedPopupOpen] = (0, $cozmU.useState)(false);
    const handleOpenLinkClick = ()=>{
        setIsPopupOpen(false);
    };
    const handleEditPropertiesClick = ()=>{
        setIsConfiguring(true);
        setNewItemType(undefined);
    };
    const handleMoveUpClick = ()=>{
        moveItem(item, index - 1, parentId);
        setIsPopupOpen(false);
    };
    const handleMoveDownClick = ()=>{
        moveItem(item, index + 1, parentId);
        setIsPopupOpen(false);
    };
    const handleSubItemPopupClose = ()=>setIsNestedPopupOpen(false);
    const reachedMaximumNestingLevel = level >= (0, $5a630f948a937af8$export$3fcb5b76d26bf473)();
    const reachedMaximumItems = numberItems >= (0, $5a630f948a937af8$export$8555315c03db9dc2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, item.type === (0, $8Yw12.ITEM).LINK && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
        href: item.link,
        target: "_blank",
        onClick: handleOpenLinkClick,
        isDisabled: !item.link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).openLinkButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        onClick: handleEditPropertiesClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).editPropertiesButtonText)), item.type === (0, $8Yw12.ITEM).MENU && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).itemCreationDisabledTooltipText),
        canAppear: ()=>reachedMaximumItems
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: isNestedPopupOpen,
        placement: "auto",
        onClose: handleSubItemPopupClose,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a07483b640d0b00$export$92ef8f592bb35119), {
                isAddMenuSubItemDisabled: reachedMaximumNestingLevel,
                setIsConfiguring: setIsConfiguring,
                setNewItemType: setNewItemType
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                ...triggerProps,
                isDisabled: reachedMaximumItems,
                isSelected: isNestedPopupOpen,
                onClick: ()=>setIsNestedPopupOpen(true),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
                    label: "Add sub item"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).addSubItemButtonText))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        isDisabled: isFirst,
        onClick: handleMoveUpClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).moveItemUpText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        isDisabled: isLast,
        onClick: handleMoveDownClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).moveItemDownText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d8213e10e6bbe53$export$9ed99085725e367e), {
        item: item,
        extensionActions: extensionActions
    }));
};





const $feca6551d72aad31$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    moreButtonLabel: {
        id: "company-hub.links-menu-extension.config-panel.property-config.more-button-label",
        defaultMessage: "More"
    }
});


const $aaf980be749ec808$var$wrapperStyles = (0, $buxP3.xcss)({
    height: '32px',
    paddingLeft: 'space.100',
    paddingRight: 'space.050'
});
const $aaf980be749ec808$var$unselectedStyles = (0, $buxP3.xcss)({
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        borderRadius: 'radius.small'
    }
});
const $aaf980be749ec808$var$selectedStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small',
    background: "var(--ds-background-selected, #E9F2FE)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-selected, #1868DB)"}`
});
const $aaf980be749ec808$var$entryStyles = (0, $buxP3.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $aaf980be749ec808$var$titleStyles = (0, $buxP3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $aaf980be749ec808$export$b2ddf7d8171e1c98 = 16;
// Config panel is not resizable
const $aaf980be749ec808$var$APPROX_BUFFERED_CONFIG_PANEL_WIDTH = 255;
const $aaf980be749ec808$export$52cf4656f89a6ced = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(44);
    const { extensionActions: extensionActions, isFirst: isFirst, isLast: isLast, index: index, item: item, parentId: parentId, level: level, numberItems: numberItems, isDragging: isDragging } = t0;
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(false);
    const [isConfiguring, setIsConfiguring] = (0, $cozmU.useState)(false);
    const [newItemType, setNewItemType] = (0, $cozmU.useState)(undefined);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setIsPopupOpen(false);
            setIsConfiguring(false);
            setNewItemType(undefined);
        };
        $[0] = t1;
    } else t1 = $[0];
    const handleClose = t1;
    let t2;
    if ($[1] !== isPopupOpen) {
        t2 = ()=>{
            setIsPopupOpen(!isPopupOpen);
            setIsConfiguring(false);
            setNewItemType(undefined);
        };
        $[1] = isPopupOpen;
        $[2] = t2;
    } else t2 = $[2];
    const handleMoreButtonClick = t2;
    let t3;
    if ($[3] !== item || $[4] !== newItemType) {
        t3 = newItemType ? {
            newItemType: newItemType,
            parentId: item.itemId
        } : {
            existingItem: item
        };
        $[3] = item;
        $[4] = newItemType;
        $[5] = t3;
    } else t3 = $[5];
    const configProps = t3;
    const popupAdjustLeftPx = $aaf980be749ec808$var$APPROX_BUFFERED_CONFIG_PANEL_WIDTH - $aaf980be749ec808$export$b2ddf7d8171e1c98 * level;
    const popupAdjustDownPx = item?.type === (0, $8Yw12.ITEM).MENU ? 50 : 80;
    const t4 = isConfiguring ? $aaf980be749ec808$var$selectedStyles : $aaf980be749ec808$var$unselectedStyles;
    let t5;
    if ($[6] !== t4) {
        t5 = [
            $aaf980be749ec808$var$wrapperStyles,
            t4
        ];
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== item) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57fd414daf32f352$export$f508444e7933c2b1), {
            item: item
        });
        $[8] = item;
        $[9] = t6;
    } else t6 = $[9];
    const t7 = `links-menu-item-title-${index}-${item.itemId}`;
    let t8;
    if ($[10] !== item.title || $[11] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $aaf980be749ec808$var$titleStyles,
            testId: t7
        }, item.title);
        $[10] = item.title;
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== t6 || $[14] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            columnGap: "space.100",
            xcss: $aaf980be749ec808$var$entryStyles
        }, t6, t8);
        $[13] = t6;
        $[14] = t8;
        $[15] = t9;
    } else t9 = $[15];
    const t10 = isPopupOpen && !isDragging;
    let t11;
    if ($[16] !== isConfiguring || $[17] !== popupAdjustDownPx || $[18] !== popupAdjustLeftPx) {
        t11 = isConfiguring ? [
            popupAdjustDownPx,
            popupAdjustLeftPx
        ] : undefined;
        $[16] = isConfiguring;
        $[17] = popupAdjustDownPx;
        $[18] = popupAdjustLeftPx;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== configProps || $[21] !== extensionActions || $[22] !== index || $[23] !== isConfiguring || $[24] !== isFirst || $[25] !== isLast || $[26] !== item || $[27] !== level || $[28] !== numberItems || $[29] !== parentId) {
        t12 = (t13)=>{
            const { update: update } = t13;
            if (isConfiguring) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $66131ca3daf51fef$export$7aec99e1cacc0106), {
                extensionActions: extensionActions,
                handleClose: handleClose,
                update: update,
                ...configProps
            });
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87fb9051120c4608$export$4837f2e6e199256e), {
                extensionActions: extensionActions,
                isFirst: isFirst,
                isLast: isLast,
                index: index,
                level: level,
                item: item,
                parentId: parentId,
                numberItems: numberItems,
                setIsPopupOpen: setIsPopupOpen,
                setIsConfiguring: setIsConfiguring,
                setNewItemType: setNewItemType
            });
        };
        $[20] = configProps;
        $[21] = extensionActions;
        $[22] = index;
        $[23] = isConfiguring;
        $[24] = isFirst;
        $[25] = isLast;
        $[26] = item;
        $[27] = level;
        $[28] = numberItems;
        $[29] = parentId;
        $[30] = t12;
    } else t12 = $[30];
    let t13;
    if ($[31] !== handleMoreButtonClick || $[32] !== isConfiguring || $[33] !== isPopupOpen) {
        t13 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                onClick: handleMoreButtonClick,
                appearance: "subtle",
                spacing: "compact",
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $feca6551d72aad31$export$defe85febe8b728c).moreButtonLabel),
                isSelected: isPopupOpen && !isConfiguring
            });
        $[31] = handleMoreButtonClick;
        $[32] = isConfiguring;
        $[33] = isPopupOpen;
        $[34] = t13;
    } else t13 = $[34];
    let t14;
    if ($[35] !== t10 || $[36] !== t11 || $[37] !== t12 || $[38] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            isOpen: t10,
            onClose: handleClose,
            placement: "auto",
            offset: t11,
            content: t12,
            trigger: t13
        });
        $[35] = t10;
        $[36] = t11;
        $[37] = t12;
        $[38] = t13;
        $[39] = t14;
    } else t14 = $[39];
    let t15;
    if ($[40] !== t14 || $[41] !== t5 || $[42] !== t9) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            justifyContent: "space-between",
            xcss: t5
        }, t9, t14);
        $[40] = t14;
        $[41] = t5;
        $[42] = t9;
        $[43] = t15;
    } else t15 = $[43];
    return t15;
} : ({ extensionActions: extensionActions, isFirst: isFirst, isLast: isLast, index: index, item: item, parentId: parentId, level: level, numberItems: numberItems, isDragging: isDragging })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(false);
    const [isConfiguring, setIsConfiguring] = (0, $cozmU.useState)(false);
    const [newItemType, setNewItemType] = (0, $cozmU.useState)(undefined);
    const handleClose = ()=>{
        setIsPopupOpen(false);
        setIsConfiguring(false);
        setNewItemType(undefined);
    };
    const handleMoreButtonClick = ()=>{
        setIsPopupOpen(!isPopupOpen);
        setIsConfiguring(false);
        setNewItemType(undefined);
    };
    const configProps = newItemType ? {
        newItemType: newItemType,
        parentId: item.itemId
    } : {
        existingItem: item
    };
    const popupAdjustLeftPx = $aaf980be749ec808$var$APPROX_BUFFERED_CONFIG_PANEL_WIDTH - $aaf980be749ec808$export$b2ddf7d8171e1c98 * level;
    const popupAdjustDownPx = item?.type === (0, $8Yw12.ITEM).MENU ? 50 : 80;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        alignItems: "center",
        justifyContent: "space-between",
        xcss: [
            $aaf980be749ec808$var$wrapperStyles,
            isConfiguring ? $aaf980be749ec808$var$selectedStyles : $aaf980be749ec808$var$unselectedStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        alignItems: "center",
        columnGap: "space.100",
        xcss: $aaf980be749ec808$var$entryStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57fd414daf32f352$export$f508444e7933c2b1), {
        item: item
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $aaf980be749ec808$var$titleStyles,
        testId: `links-menu-item-title-${index}-${item.itemId}`
    }, item.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: isPopupOpen && !isDragging,
        onClose: handleClose,
        placement: "auto",
        // move popup to left of list item when item config is invoked,
        // so user can see what they are editing
        offset: isConfiguring ? [
            popupAdjustDownPx,
            popupAdjustLeftPx
        ] : undefined,
        content: ({ update: update })=>{
            if (isConfiguring) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $66131ca3daf51fef$export$7aec99e1cacc0106), {
                extensionActions: extensionActions,
                handleClose: handleClose,
                update: update,
                ...configProps
            });
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87fb9051120c4608$export$4837f2e6e199256e), {
                extensionActions: extensionActions,
                isFirst: isFirst,
                isLast: isLast,
                index: index,
                level: level,
                item: item,
                parentId: parentId,
                numberItems: numberItems,
                setIsPopupOpen: setIsPopupOpen,
                setIsConfiguring: setIsConfiguring,
                setNewItemType: setNewItemType
            });
        },
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                onClick: handleMoreButtonClick,
                appearance: "subtle",
                spacing: "compact",
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $feca6551d72aad31$export$defe85febe8b728c).moreButtonLabel),
                isSelected: isPopupOpen && !isConfiguring
            })
    }));
};


const $0c52aed093252330$var$treeStyles = null;
const $0c52aed093252330$export$b7801be30ff65271 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { extensionActions: extensionActions, nodes: nodes, parentId: parentId, level: t1, numberItems: numberItems } = t0;
    const level = t1 === undefined ? 0 : t1;
    const { moveItem: moveItem } = extensionActions;
    let t2;
    if ($[0] !== moveItem) {
        t2 = ()=>(0, $iSrRp.monitorForElements)({
                onDrop (t3) {
                    const { source: source, location: location } = t3;
                    const destination = location.current.dropTargets[0];
                    if (destination?.data && source?.data) {
                        const sourceData = source.data;
                        const destinationData = destination.data;
                        const instruction = (0, $1zKNa.extractInstruction)(destinationData);
                        if (sourceData.id !== destinationData.id) {
                            if (instruction?.type === "reorder-above" || instruction?.type === "reorder-below") {
                                const index = destinationData.index || 0;
                                let newIndex = instruction?.type === "reorder-above" ? index : index + 1;
                                if (sourceData.parentId === destinationData.parentId) {
                                    if (sourceData.index < index) newIndex = instruction?.type === "reorder-above" ? index - 1 : index;
                                }
                                moveItem(sourceData.item, newIndex, destinationData.parentId);
                            }
                            if (instruction?.type === "make-child") moveItem(sourceData.item, 0, destinationData.id);
                        }
                    }
                }
            });
        $[0] = moveItem;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== moveItem || $[3] !== nodes) {
        t3 = [
            nodes,
            moveItem
        ];
        $[2] = moveItem;
        $[3] = nodes;
        $[4] = t3;
    } else t3 = $[4];
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            listStyleType: "none"
        };
        t5 = (0, $hekY6.default)([
            "_19bvidpf _17d4pxbi"
        ]);
        $[5] = t4;
        $[6] = t5;
    } else {
        t4 = $[5];
        t5 = $[6];
    }
    let t6;
    if ($[7] !== extensionActions || $[8] !== level || $[9] !== nodes || $[10] !== numberItems || $[11] !== parentId) {
        let t7;
        if ($[13] !== extensionActions || $[14] !== level || $[15] !== nodes.length || $[16] !== numberItems || $[17] !== parentId) {
            t7 = (node, index_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0c52aed093252330$var$LinksMenuItemTreeNode, {
                    key: node.itemId,
                    extensionActions: extensionActions,
                    node: node,
                    isFirst: index_0 === 0,
                    isLast: index_0 === nodes.length - 1,
                    index: index_0,
                    parentId: parentId,
                    level: level,
                    numberItems: numberItems
                });
            $[13] = extensionActions;
            $[14] = level;
            $[15] = nodes.length;
            $[16] = numberItems;
            $[17] = parentId;
            $[18] = t7;
        } else t7 = $[18];
        t6 = nodes.map(t7);
        $[7] = extensionActions;
        $[8] = level;
        $[9] = nodes;
        $[10] = numberItems;
        $[11] = parentId;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[19] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
            style: t4,
            className: t5
        }, t6);
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
} : ({ extensionActions: extensionActions, nodes: nodes, parentId: parentId, level: level = 0, numberItems: numberItems })=>{
    const { moveItem: moveItem } = extensionActions;
    (0, $cozmU.useEffect)(()=>{
        return (0, $iSrRp.monitorForElements)({
            onDrop ({ source: source, location: location }) {
                const destination = location.current.dropTargets[0];
                if (destination?.data && source?.data) {
                    const sourceData = source.data;
                    const destinationData = destination.data;
                    const instruction = (0, $1zKNa.extractInstruction)(destinationData); // source and destination should be unique
                    if (sourceData.id !== destinationData.id) {
                        if (instruction?.type === 'reorder-above' || instruction?.type === 'reorder-below') {
                            // if source and destination have same parent, then we are reordering within the list
                            // and the index depends on whether the source is above or below the destination
                            const index = destinationData.index || 0;
                            let newIndex = instruction?.type === 'reorder-above' ? index : index + 1;
                            if (sourceData.parentId === destinationData.parentId) {
                                if (sourceData.index < index) newIndex = instruction?.type === 'reorder-above' ? index - 1 : index;
                            }
                            moveItem(sourceData.item, newIndex, destinationData.parentId);
                        }
                        if (instruction?.type === 'make-child') moveItem(sourceData.item, 0, destinationData.id);
                    }
                }
            }
        });
    }, [
        nodes,
        moveItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        style: {
            listStyleType: 'none'
        },
        className: (0, $hekY6.default)([
            "_19bvidpf _17d4pxbi"
        ])
    }, nodes.map((node, index_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0c52aed093252330$var$LinksMenuItemTreeNode, {
            key: node.itemId,
            extensionActions: extensionActions,
            node: node,
            isFirst: index_0 === 0,
            isLast: index_0 === nodes.length - 1,
            index: index_0,
            parentId: parentId,
            level: level,
            numberItems: numberItems
        })));
};
const $0c52aed093252330$var$LinksMenuItemTreeNode = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { extensionActions: extensionActions, node: node, isFirst: isFirst, isLast: isLast, index: index, parentId: parentId, level: level, numberItems: numberItems } = t0;
    const [isDragging, setIsDragging] = (0, $cozmU.useState)(false);
    const newLevel = level + 1;
    let t1;
    if ($[0] !== extensionActions || $[1] !== index || $[2] !== isDragging || $[3] !== isFirst || $[4] !== isLast || $[5] !== level || $[6] !== node || $[7] !== numberItems || $[8] !== parentId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aaf980be749ec808$export$52cf4656f89a6ced), {
            key: node.itemId,
            extensionActions: extensionActions,
            index: index,
            isFirst: isFirst,
            isLast: isLast,
            item: node,
            parentId: parentId,
            level: level,
            numberItems: numberItems,
            isDragging: isDragging
        });
        $[0] = extensionActions;
        $[1] = index;
        $[2] = isDragging;
        $[3] = isFirst;
        $[4] = isLast;
        $[5] = level;
        $[6] = node;
        $[7] = numberItems;
        $[8] = parentId;
        $[9] = t1;
    } else t1 = $[9];
    let t2;
    if ($[10] !== index || $[11] !== isDragging || $[12] !== level || $[13] !== node || $[14] !== parentId || $[15] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5b5e7c02851da02$export$588e2663e0be32a3), {
            item: node,
            index: index,
            parentId: parentId,
            isDragging: isDragging,
            setIsDragging: setIsDragging,
            level: level
        }, t1);
        $[10] = index;
        $[11] = isDragging;
        $[12] = level;
        $[13] = node;
        $[14] = parentId;
        $[15] = t1;
        $[16] = t2;
    } else t2 = $[16];
    let t3;
    if ($[17] !== extensionActions || $[18] !== isDragging || $[19] !== newLevel || $[20] !== node || $[21] !== numberItems) {
        t3 = node.childItems && !isDragging && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0c52aed093252330$export$b7801be30ff65271, {
            extensionActions: extensionActions,
            nodes: node.childItems,
            parentId: node.itemId,
            level: newLevel,
            numberItems: numberItems
        });
        $[17] = extensionActions;
        $[18] = isDragging;
        $[19] = newLevel;
        $[20] = node;
        $[21] = numberItems;
        $[22] = t3;
    } else t3 = $[22];
    let t4;
    if ($[23] !== t2 || $[24] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, t2, t3);
        $[23] = t2;
        $[24] = t3;
        $[25] = t4;
    } else t4 = $[25];
    return t4;
} : ({ extensionActions: extensionActions, node: node, isFirst: isFirst, isLast: isLast, index: index, parentId: parentId, level: level, numberItems: numberItems })=>{
    const [isDragging, setIsDragging] = (0, $cozmU.useState)(false);
    const newLevel = level + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5b5e7c02851da02$export$588e2663e0be32a3), {
        item: node,
        index: index,
        parentId: parentId,
        isDragging: isDragging,
        setIsDragging: setIsDragging,
        level: level
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aaf980be749ec808$export$52cf4656f89a6ced), {
        key: node.itemId,
        extensionActions: extensionActions,
        index: index,
        isFirst: isFirst,
        isLast: isLast,
        item: node,
        parentId: parentId,
        level: level,
        numberItems: numberItems,
        isDragging: isDragging
    })), node.childItems && !isDragging && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0c52aed093252330$export$b7801be30ff65271, {
        extensionActions: extensionActions,
        nodes: node.childItems,
        parentId: node.itemId,
        level: newLevel,
        numberItems: numberItems
    }));
};


















var $gFEZF = parcelRequire("gFEZF");





var $4ez2K = parcelRequire("4ez2K");









const $810d9a2aadbfde1e$var$message = (0, $kSwu1.defineMessages)({
    newItemButtonText: {
        id: "company-hub.links-menu-extension.config-panel.new-item-button.text",
        defaultMessage: "New item"
    },
    itemCreationDisabledTooltipText: {
        id: "company-hub.links-menu-extension.config-panel.new-item-button.disabled.tooltip-text",
        defaultMessage: "You have reached the maximum number of items that can be added to a links menu."
    }
});
var $810d9a2aadbfde1e$export$2e2bcd8739ae039 = $810d9a2aadbfde1e$var$message;



const $33cfc65cb4c0f1da$export$f9da8ac0bf4c10b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { extensionActions: extensionActions, numberItems: numberItems } = t0;
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(false);
    const [isConfiguring, setIsConfiguring] = (0, $cozmU.useState)(false);
    const [newItemType, setNewItemType] = (0, $cozmU.useState)(undefined);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setIsPopupOpen(false);
            setIsConfiguring(false);
            setNewItemType(undefined);
        };
        $[0] = t1;
    } else t1 = $[0];
    const handleOnClose = t1;
    const isAddDisabled = numberItems >= (0, $5a630f948a937af8$export$8555315c03db9dc2)();
    let t2;
    if ($[1] !== isPopupOpen) {
        t2 = ()=>{
            setIsPopupOpen(!isPopupOpen);
            setIsConfiguring(false);
            setNewItemType(undefined);
        };
        $[1] = isPopupOpen;
        $[2] = t2;
    } else t2 = $[2];
    const handleAddNewItemButtonClick = t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            "auto"
        ];
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== extensionActions || $[5] !== isConfiguring || $[6] !== newItemType) {
        t4 = (t5)=>{
            const { update: update } = t5;
            return isConfiguring && newItemType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $66131ca3daf51fef$export$7aec99e1cacc0106), {
                extensionActions: extensionActions,
                handleClose: handleOnClose,
                update: update,
                newItemType: newItemType
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a07483b640d0b00$export$92ef8f592bb35119), {
                setIsConfiguring: setIsConfiguring,
                setNewItemType: setNewItemType
            });
        };
        $[4] = extensionActions;
        $[5] = isConfiguring;
        $[6] = newItemType;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== handleAddNewItemButtonClick || $[9] !== isAddDisabled || $[10] !== isConfiguring || $[11] !== isPopupOpen) {
        t5 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $810d9a2aadbfde1e$export$2e2bcd8739ae039).itemCreationDisabledTooltipText),
                canAppear: ()=>isAddDisabled
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...triggerProps,
                onClick: handleAddNewItemButtonClick,
                isSelected: isPopupOpen && !isConfiguring,
                isDisabled: isAddDisabled,
                shouldFitContainer: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
                alignItems: "center",
                justifyContent: "center",
                gap: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                label: ""
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $810d9a2aadbfde1e$export$2e2bcd8739ae039).newItemButtonText))));
        $[8] = handleAddNewItemButtonClick;
        $[9] = isAddDisabled;
        $[10] = isConfiguring;
        $[11] = isPopupOpen;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== isPopupOpen || $[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            isOpen: isPopupOpen,
            onClose: handleOnClose,
            placement: "bottom-end",
            fallbackPlacements: t3,
            content: t4,
            trigger: t5
        });
        $[13] = isPopupOpen;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ extensionActions: extensionActions, numberItems: numberItems })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(false);
    const [isConfiguring, setIsConfiguring] = (0, $cozmU.useState)(false);
    const [newItemType, setNewItemType] = (0, $cozmU.useState)(undefined);
    const handleOnClose = ()=>{
        setIsPopupOpen(false);
        setIsConfiguring(false);
        setNewItemType(undefined);
    };
    const isAddDisabled = numberItems >= (0, $5a630f948a937af8$export$8555315c03db9dc2)();
    const handleAddNewItemButtonClick = ()=>{
        setIsPopupOpen(!isPopupOpen);
        setIsConfiguring(false);
        setNewItemType(undefined);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: isPopupOpen,
        onClose: handleOnClose,
        placement: "bottom-end",
        fallbackPlacements: [
            'auto'
        ],
        content: ({ update: update })=>isConfiguring && newItemType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $66131ca3daf51fef$export$7aec99e1cacc0106), {
                extensionActions: extensionActions,
                handleClose: handleOnClose,
                update: update,
                newItemType: newItemType
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a07483b640d0b00$export$92ef8f592bb35119), {
                setIsConfiguring: setIsConfiguring,
                setNewItemType: setNewItemType
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $810d9a2aadbfde1e$export$2e2bcd8739ae039).itemCreationDisabledTooltipText),
                canAppear: ()=>isAddDisabled
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...triggerProps,
                onClick: handleAddNewItemButtonClick,
                isSelected: isPopupOpen && !isConfiguring,
                isDisabled: isAddDisabled,
                shouldFitContainer: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
                alignItems: "center",
                justifyContent: "center",
                gap: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                label: ""
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $810d9a2aadbfde1e$export$2e2bcd8739ae039).newItemButtonText))))
    });
};


const $56913d8e8d66d0b7$var$itemsTabStyles = (0, $buxP3.xcss)({
    width: '100%',
    paddingTop: 'space.200'
});
const $56913d8e8d66d0b7$var$itemsTreeStyles = (0, $buxP3.xcss)({
    marginTop: 'space.200'
});
const $56913d8e8d66d0b7$export$869bcddc95554001 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { extensionParameters: extensionParameters, extensionActions: extensionActions } = t0;
    let t1;
    if ($[0] !== extensionParameters.items) {
        t1 = (0, $5a630f948a937af8$export$b503abd6de82eca1)(extensionParameters.items);
        $[0] = extensionParameters.items;
        $[1] = t1;
    } else t1 = $[1];
    const totalItemCount = t1;
    let t2;
    if ($[2] !== extensionActions || $[3] !== totalItemCount) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33cfc65cb4c0f1da$export$f9da8ac0bf4c10b), {
            extensionActions: extensionActions,
            numberItems: totalItemCount
        });
        $[2] = extensionActions;
        $[3] = totalItemCount;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== extensionActions || $[6] !== extensionParameters.items || $[7] !== totalItemCount) {
        t3 = extensionParameters.items && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0c52aed093252330$export$b7801be30ff65271), {
            extensionActions: extensionActions,
            nodes: extensionParameters.items,
            numberItems: totalItemCount
        });
        $[5] = extensionActions;
        $[6] = extensionParameters.items;
        $[7] = totalItemCount;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            direction: "column",
            xcss: $56913d8e8d66d0b7$var$itemsTreeStyles
        }, t3);
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== t2 || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            direction: "column",
            xcss: $56913d8e8d66d0b7$var$itemsTabStyles
        }, t2, t4);
        $[11] = t2;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
} : ({ extensionParameters: extensionParameters, extensionActions: extensionActions })=>{
    const totalItemCount = (0, $cozmU.useMemo)(()=>(0, $5a630f948a937af8$export$b503abd6de82eca1)(extensionParameters.items), [
        extensionParameters.items
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "column",
        xcss: $56913d8e8d66d0b7$var$itemsTabStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33cfc65cb4c0f1da$export$f9da8ac0bf4c10b), {
        extensionActions: extensionActions,
        numberItems: totalItemCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "column",
        xcss: $56913d8e8d66d0b7$var$itemsTreeStyles
    }, extensionParameters.items && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0c52aed093252330$export$b7801be30ff65271), {
        extensionActions: extensionActions,
        nodes: extensionParameters.items,
        numberItems: totalItemCount
    })));
};





const $4ea311f5ca17d214$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title: {
        id: "company-hub.links-menu-extension.config-panel.title",
        defaultMessage: "Links menu"
    },
    preamble: {
        id: "company-hub.links-menu-extension.config-panel.preamble",
        defaultMessage: "Add links and organize them with submenus. {linksMenuSupportLink}"
    },
    preambleWithoutSupportLink: {
        id: "company-hub.links-menu-extension.config-panel.preamble-without-support-link",
        defaultMessage: "Add links and organize them with submenus."
    },
    preambleSupportLinkLabel: {
        id: "company-hub.links-menu-extension.config-panel.preamble-link.label",
        defaultMessage: "Learn more about links menu"
    },
    itemsLabel: {
        id: "company-hub.links-menu-extension.config-panel.items.label",
        defaultMessage: "Items"
    },
    stylesLabel: {
        id: "company-hub.links-menu-extension.config-panel.styles.label",
        defaultMessage: "Styles"
    }
});

















var $4yUlE = parcelRequire("4yUlE");

var $5ddnJ = parcelRequire("5ddnJ");




















var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");


var $4ikjJ = parcelRequire("4ikjJ");


var $eBTV9 = parcelRequire("eBTV9");

var $f9375c5bd6aa36bb$exports = {};
$f9375c5bd6aa36bb$exports = new URL("CenterAlignment.d485d2ee.svg", import.meta.url).toString();

var $dc657cb9a098154e$exports = {};
$dc657cb9a098154e$exports = new URL("LeftAlignment.39a4cc93.svg", import.meta.url).toString();

var $dc97e266cc3b1d6b$exports = {};
$dc97e266cc3b1d6b$exports = new URL("RightAlignment.ee73794d.svg", import.meta.url).toString();








const $62ffd5ec12cb339a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    alignmentSectionTitle: {
        id: "company-hub.links-menu-extension.alignment.title",
        defaultMessage: "Alignment"
    },
    centerOption: {
        id: "company-hub.links-menu-extension.center.option",
        defaultMessage: "Center"
    },
    rightOption: {
        id: "company-hub.links-menu-extension.right.option",
        defaultMessage: "Right"
    },
    leftOption: {
        id: "company-hub.links-menu-extension.left.option",
        defaultMessage: "Left"
    },
    collapseSectionLabel: {
        id: "company-hub.links-menu-extension.section.collapse.label",
        defaultMessage: "Collapse section"
    },
    expandSectionLabel: {
        id: "company-hub.links-menu-extension.section.expand.label",
        defaultMessage: "Expand section"
    },
    fixedOption: {
        id: "company-hub.links-menu-extension.fixed.option",
        defaultMessage: "Fixed at top"
    }
});


const $8df22c16dac442a4$var$styles = {
    options: "_2rko12b0 _1h6d1l7x _189ee4h9 _1dqonqa1 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _bfhksm61 _4cvxq98m _irr3daj9"
};
const $8df22c16dac442a4$export$f77ede0ff8fdecea = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { alignment: alignment, updateAlignment: updateAlignment } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let T0;
    let T1;
    let t1;
    let t2;
    let t3;
    if ($[0] !== alignment || $[1] !== formatMessage || $[2] !== updateAlignment) {
        const alignmentOptions = [
            {
                option: (0, $8Yw12.ALIGNMENT).CENTER,
                label: (0, $62ffd5ec12cb339a$export$defe85febe8b728c).centerOption,
                image: (0, (/*@__PURE__*/$parcel$interopDefault($f9375c5bd6aa36bb$exports)))
            },
            {
                option: (0, $8Yw12.ALIGNMENT).RIGHT,
                label: (0, $62ffd5ec12cb339a$export$defe85febe8b728c).rightOption,
                image: (0, (/*@__PURE__*/$parcel$interopDefault($dc97e266cc3b1d6b$exports)))
            },
            {
                option: (0, $8Yw12.ALIGNMENT).LEFT,
                label: (0, $62ffd5ec12cb339a$export$defe85febe8b728c).leftOption,
                image: (0, (/*@__PURE__*/$parcel$interopDefault($dc657cb9a098154e$exports)))
            }
        ];
        T1 = (0, $eBTV9.CollapsibleItem);
        if ($[8] !== formatMessage) {
            t3 = formatMessage((0, $62ffd5ec12cb339a$export$defe85febe8b728c).alignmentSectionTitle);
            $[8] = formatMessage;
            $[9] = t3;
        } else t3 = $[9];
        T0 = (0, $dinVW.default);
        t1 = "space.200";
        t2 = alignmentOptions.map((t4)=>{
            const { option: option, label: label, image: image } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
                key: option,
                xcss: $8df22c16dac442a4$var$styles.options,
                onClick: ()=>updateAlignment(option)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
                spread: "space-between",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
                value: "default radio",
                label: formatMessage(label),
                name: `radio-${option}`,
                testId: `radio-${option}${alignment === option ? "--selected" : ""}`,
                isChecked: alignment === option
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                src: image,
                alt: ""
            })));
        });
        $[0] = alignment;
        $[1] = formatMessage;
        $[2] = updateAlignment;
        $[3] = T0;
        $[4] = T1;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else {
        T0 = $[3];
        T1 = $[4];
        t1 = $[5];
        t2 = $[6];
        t3 = $[7];
    }
    let t4;
    if ($[10] !== T0 || $[11] !== t1 || $[12] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            space: t1
        }, t2);
        $[10] = T0;
        $[11] = t1;
        $[12] = t2;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== T1 || $[15] !== t3 || $[16] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T1, {
            title: t3
        }, t4);
        $[14] = T1;
        $[15] = t3;
        $[16] = t4;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
} : ({ alignment: alignment, updateAlignment: updateAlignment })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const alignmentOptions = [
        {
            option: (0, $8Yw12.ALIGNMENT).CENTER,
            label: (0, $62ffd5ec12cb339a$export$defe85febe8b728c).centerOption,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($f9375c5bd6aa36bb$exports)))
        },
        {
            option: (0, $8Yw12.ALIGNMENT).RIGHT,
            label: (0, $62ffd5ec12cb339a$export$defe85febe8b728c).rightOption,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($dc97e266cc3b1d6b$exports)))
        },
        {
            option: (0, $8Yw12.ALIGNMENT).LEFT,
            label: (0, $62ffd5ec12cb339a$export$defe85febe8b728c).leftOption,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($dc657cb9a098154e$exports)))
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eBTV9.CollapsibleItem), {
        title: formatMessage((0, $62ffd5ec12cb339a$export$defe85febe8b728c).alignmentSectionTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.200"
    }, alignmentOptions.map(({ option: option, label: label, image: image })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
            key: option,
            xcss: $8df22c16dac442a4$var$styles.options,
            onClick: ()=>updateAlignment(option)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            spread: "space-between",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
            value: "default radio",
            label: formatMessage(label),
            name: `radio-${option}`,
            testId: `radio-${option}${alignment === option ? '--selected' : ''}`,
            isChecked: alignment === option
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: image,
            alt: ""
        }))))));
};















var $w6R6I = parcelRequire("w6R6I");


var $lRXxm = parcelRequire("lRXxm");


var $bsSbN = parcelRequire("bsSbN");


var $jAG9k = parcelRequire("jAG9k");














var $cXCJB = parcelRequire("cXCJB");

var $4sYZY = parcelRequire("4sYZY");







var $1ipaC = parcelRequire("1ipaC");


var $e9Sxn = parcelRequire("e9Sxn");

var $gKJso = parcelRequire("gKJso");


var $4WDWC = parcelRequire("4WDWC");


var $4pBmf = parcelRequire("4pBmf");


var $iJCWb = parcelRequire("iJCWb");





var $eafQX = parcelRequire("eafQX");







const $ff55793b554baa82$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    backgroundTitle: {
        id: "company-hub.links-menu-extension.background.title",
        defaultMessage: "Background"
    },
    backgroundColor: {
        id: "company-hub.links-menu-extension.background.color",
        defaultMessage: "Background color"
    },
    borderColor: {
        id: "company-hub.links-menu-extension.border.color",
        defaultMessage: "Border color"
    },
    borderPosition: {
        id: "company-hub.links-menu-extension.border.position",
        defaultMessage: "Border position"
    },
    noBorderLabel: {
        id: "company-hub.links-menu-extension.no.border.label-text",
        defaultMessage: "None"
    },
    allBordersLabel: {
        id: "company-hub.links-menu-extension.all.borders.label-text",
        defaultMessage: "All sides"
    },
    bottomBorderLabel: {
        id: "company-hub.links-menu-extension.bottom.border.label-text",
        defaultMessage: "Bottom border"
    },
    cornerRadius: {
        id: "company-hub.links-menu-extension.config.corner.radius.non-final",
        defaultMessage: "Corners"
    }
});


const $1659d476a828e673$var$styles = {
    borderOptionContainer: "_1rjcv77o _18zr1b66 _bfhkysee",
    dropdownTrigger: "_bfhksm61",
    border: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1",
    selected: "_1h6d1w55 _bfhk15s3"
};
const $1659d476a828e673$export$caf212aab59548f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(55);
    const { border: border, updateBorder: updateBorder, borderColor: borderColor, updateBorderColor: updateBorderColor, fillColor: fillColor, updateFillColor: updateFillColor, cornerStyle: cornerStyle, updateCornerStyle: updateCornerStyle, cornerRadius: cornerRadius, updateCornerRadius: updateCornerRadius, isReadableFillColor: isReadableFillColor } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const { branding: branding } = (0, $cfM7x.useProductDependencies)();
    let t1;
    if ($[0] !== branding) {
        t1 = branding ?? {};
        $[0] = branding;
        $[1] = t1;
    } else t1 = $[1];
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = t1;
    const { backgroundColorMap: backgroundColorMap, borderColorMap: borderColorMap, emptyColorMap: emptyColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const theming = (0, $4pBmf.useHubTheming)();
    const isAdvancedThemingEnabled = theming?.isAdvancedThemingEnabled === true;
    const palette = isAdvancedThemingEnabled ? theming?.palette : undefined;
    const primaryColor = isAdvancedThemingEnabled ? theming?.primaryColor : undefined;
    const v2BgMap = isAdvancedThemingEnabled ? theming?.brandBackgroundColorMap : undefined;
    const v2BorderMap = isAdvancedThemingEnabled ? theming?.brandBorderColorMap : undefined;
    let t2;
    if ($[2] !== fillColor || $[3] !== palette || $[4] !== primaryColor) {
        t2 = palette ? (0, $e9Sxn.resolveAdfColorForPicker)(fillColor, palette, "primary.200", primaryColor) : fillColor;
        $[2] = fillColor;
        $[3] = palette;
        $[4] = primaryColor;
        $[5] = t2;
    } else t2 = $[5];
    const fillPickerValue = t2;
    let t3;
    if ($[6] !== borderColor || $[7] !== palette || $[8] !== primaryColor) {
        t3 = palette ? (0, $e9Sxn.resolveAdfColorForPicker)(borderColor, palette, "primary.200", primaryColor) : borderColor;
        $[6] = borderColor;
        $[7] = palette;
        $[8] = primaryColor;
        $[9] = t3;
    } else t3 = $[9];
    const borderPickerValue = t3;
    let t4;
    if ($[10] !== palette || $[11] !== updateFillColor) {
        t4 = (color)=>{
            updateFillColor(palette ? (0, $gKJso.toAdfColor)(color, palette) : color);
        };
        $[10] = palette;
        $[11] = updateFillColor;
        $[12] = t4;
    } else t4 = $[12];
    const handleFillColorChange = t4;
    let t5;
    if ($[13] !== border || $[14] !== palette || $[15] !== updateBorder || $[16] !== updateBorderColor) {
        t5 = (color_0)=>{
            if (border === (0, $8Yw12.BORDER).NONE) updateBorder((0, $8Yw12.BORDER).ALL_SIDES);
            updateBorderColor(palette ? (0, $gKJso.toAdfColor)(color_0, palette) : color_0);
        };
        $[13] = border;
        $[14] = palette;
        $[15] = updateBorder;
        $[16] = updateBorderColor;
        $[17] = t5;
    } else t5 = $[17];
    const handleBorderColorChange = t5;
    let t6;
    if ($[18] !== updateBorder) {
        t6 = (borderOption)=>updateBorder(borderOption);
        $[18] = updateBorder;
        $[19] = t6;
    } else t6 = $[19];
    const handleBorderOptionClick = t6;
    let t7;
    if ($[20] !== formatMessage) {
        t7 = formatMessage((0, $ff55793b554baa82$export$defe85febe8b728c).backgroundTitle);
        $[20] = formatMessage;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $ff55793b554baa82$export$defe85febe8b728c).backgroundColor));
        $[22] = t8;
    } else t8 = $[22];
    const t9 = v2BgMap ?? (hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap);
    let t10;
    if ($[23] !== fillPickerValue || $[24] !== handleFillColorChange || $[25] !== isReadableFillColor || $[26] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            alignBlock: "center",
            spread: "space-between"
        }, t8, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
            analyticsSource: "linksMenuExtensionConfigBackgroundColor",
            builtInColorMap: t9,
            isReadableColor: isReadableFillColor,
            onChange: handleFillColorChange,
            value: fillPickerValue,
            pickerTitle: (0, $ff55793b554baa82$export$defe85febe8b728c).backgroundColor,
            showCustomPalette: true
        }));
        $[23] = fillPickerValue;
        $[24] = handleFillColorChange;
        $[25] = isReadableFillColor;
        $[26] = t9;
        $[27] = t10;
    } else t10 = $[27];
    let t11;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $ff55793b554baa82$export$defe85febe8b728c).borderPosition));
        $[28] = t11;
    } else t11 = $[28];
    let t12;
    if ($[29] !== border || $[30] !== formatMessage || $[31] !== handleBorderOptionClick) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            alignBlock: "center",
            spread: "space-between"
        }, t11, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.100"
        }, [
            {
                borderOption: (0, $8Yw12.BORDER).NONE,
                label: (0, $ff55793b554baa82$export$defe85febe8b728c).noBorderLabel,
                IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($bsSbN)))
            },
            {
                borderOption: (0, $8Yw12.BORDER).ALL_SIDES,
                label: (0, $ff55793b554baa82$export$defe85febe8b728c).allBordersLabel,
                IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($lRXxm)))
            },
            {
                borderOption: (0, $8Yw12.BORDER).BOTTOM,
                label: (0, $ff55793b554baa82$export$defe85febe8b728c).bottomBorderLabel,
                IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($jAG9k)))
            }
        ].map((t13)=>{
            const { borderOption: borderOption_0, label: label, IconComponent: IconComponent } = t13;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                key: borderOption_0,
                content: formatMessage(label)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
                xcss: (0, $w6R6I.cx)($1659d476a828e673$var$styles.borderOptionContainer, $1659d476a828e673$var$styles.border, border === borderOption_0 && $1659d476a828e673$var$styles.selected),
                onClick: ()=>handleBorderOptionClick(borderOption_0),
                testId: `border-${borderOption_0}${border === borderOption_0 ? "--selected" : ""}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                color: border === borderOption_0 ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon, #292A2E)",
                label: formatMessage(label)
            })));
        })));
        $[29] = border;
        $[30] = formatMessage;
        $[31] = handleBorderOptionClick;
        $[32] = t12;
    } else t12 = $[32];
    let t13;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $ff55793b554baa82$export$defe85febe8b728c).borderColor));
        $[33] = t13;
    } else t13 = $[33];
    const t14 = v2BorderMap ?? (hideDefaultColorPalette ? emptyColorMap : borderColorMap);
    let t15;
    if ($[34] !== handleBorderColorChange) {
        t15 = (color_1)=>color_1 && handleBorderColorChange(color_1);
        $[34] = handleBorderColorChange;
        $[35] = t15;
    } else t15 = $[35];
    let t16;
    if ($[36] !== borderPickerValue || $[37] !== t14 || $[38] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            alignBlock: "center",
            spread: "space-between"
        }, t13, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
            analyticsSource: "linksMenuExtensionConfigBorderColor",
            builtInColorMap: t14,
            onChange: t15,
            value: borderPickerValue,
            pickerTitle: (0, $ff55793b554baa82$export$defe85febe8b728c).borderColor,
            showCustomPalette: true
        }));
        $[36] = borderPickerValue;
        $[37] = t14;
        $[38] = t15;
        $[39] = t16;
    } else t16 = $[39];
    let t17;
    if ($[40] !== cornerRadius || $[41] !== cornerStyle || $[42] !== isCornerRadiusEnabled || $[43] !== theming?.cornerRadius || $[44] !== updateCornerRadius || $[45] !== updateCornerStyle) {
        t17 = isCornerRadiusEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJCWb.RangeField), {
            label: (0, $ff55793b554baa82$export$defe85febe8b728c).cornerRadius,
            minValue: (0, $4WDWC.HUB_CORNER_RADIUS_MIN),
            maxValue: (0, $4WDWC.HUB_CORNER_RADIUS_MAX),
            step: (0, $4WDWC.HUB_CORNER_RADIUS_STEP),
            value: (0, $4WDWC.resolveHubCornerRadius)((0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle === (0, $8Yw12.CORNERS).SHARP ? (0, $hjUDQ.CornerStyle).SQUARED : (0, $hjUDQ.CornerStyle).ROUNDED) ?? theming?.cornerRadius),
            updateRangeValue: updateCornerRadius,
            analyticSource: "linksMenuExtensionConfigCornerRadius",
            prefix: "cornerRadius",
            unit: "px"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1ipaC.CornerStyleConfig), {
            cornerStyleValue: cornerStyle,
            updateCornerStyle: updateCornerStyle,
            roundCornerValue: (0, $8Yw12.CORNERS).ROUND,
            squareCornerValue: (0, $8Yw12.CORNERS).SHARP
        });
        $[40] = cornerRadius;
        $[41] = cornerStyle;
        $[42] = isCornerRadiusEnabled;
        $[43] = theming?.cornerRadius;
        $[44] = updateCornerRadius;
        $[45] = updateCornerStyle;
        $[46] = t17;
    } else t17 = $[46];
    let t18;
    if ($[47] !== t10 || $[48] !== t12 || $[49] !== t16 || $[50] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.200"
        }, t10, t12, t16, t17);
        $[47] = t10;
        $[48] = t12;
        $[49] = t16;
        $[50] = t17;
        $[51] = t18;
    } else t18 = $[51];
    let t19;
    if ($[52] !== t18 || $[53] !== t7) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eBTV9.CollapsibleItem), {
            title: t7
        }, t18);
        $[52] = t18;
        $[53] = t7;
        $[54] = t19;
    } else t19 = $[54];
    return t19;
} : ({ border: border, updateBorder: updateBorder, borderColor: borderColor, updateBorderColor: updateBorderColor, fillColor: fillColor, updateFillColor: updateFillColor, cornerStyle: cornerStyle, updateCornerStyle: updateCornerStyle, cornerRadius: cornerRadius, updateCornerRadius: updateCornerRadius, isReadableFillColor: isReadableFillColor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const { branding: branding } = (0, $cfM7x.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = branding ?? {};
    const { backgroundColorMap: backgroundColorMap, borderColorMap: borderColorMap, emptyColorMap: emptyColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode); // Advanced-theming opt-in: when the framework is mounted with gate ON,
    // swap the swatch palette for the 22-shade brand map and translate the
    // picker hex <-> ADF storage shape via the palette helpers. Gate OFF (or
    // when the provider isn't mounted, e.g. Confluence Company Hub) falls
    // back to today's behavior unchanged.
    const theming = (0, $4pBmf.useHubTheming)();
    const isAdvancedThemingEnabled = theming?.isAdvancedThemingEnabled === true;
    const palette = isAdvancedThemingEnabled ? theming?.palette : undefined;
    const primaryColor = isAdvancedThemingEnabled ? theming?.primaryColor : undefined;
    const v2BgMap = isAdvancedThemingEnabled ? theming?.brandBackgroundColorMap : undefined;
    const v2BorderMap = isAdvancedThemingEnabled ? theming?.brandBorderColorMap : undefined; // Bg + border are always populated by the manifest's defaultParameters
    // (or DEFAULT_STYLES), so the fallback ref isn't hit in practice — it's
    // only used by resolveAdfColorForPicker if the stored value is null.
    // Pass primary.200 as a sensible visible default.
    const fillPickerValue = palette ? (0, $e9Sxn.resolveAdfColorForPicker)(fillColor, palette, 'primary.200', primaryColor) : fillColor;
    const borderPickerValue = palette ? (0, $e9Sxn.resolveAdfColorForPicker)(borderColor, palette, 'primary.200', primaryColor) : borderColor;
    const handleFillColorChange = (color)=>{
        // Note: text auto-flip on bg change is handled centrally by the
        // `useAutoTransitioningColors` hook in the StylesTab parent, so we
        // only need to persist the bg here. When v2 is ON, store as the
        // palette var-ref form so the bg tracks future brand-color changes.
        updateFillColor(palette ? (0, $gKJso.toAdfColor)(color, palette) : color);
    };
    const handleBorderColorChange = (color_0)=>{
        if (border === (0, $8Yw12.BORDER).NONE) // if user interacts with border color then they need a border
        // position in order to see their changes
        updateBorder((0, $8Yw12.BORDER).ALL_SIDES);
         // When v2 is ON, store brand-palette swatches as palette var-refs so
        // the border tracks future brand-color changes. The 4 neutral
        // swatches (white, color.border hex, color.border.bold hex, black)
        // and any custom hex fall through `toAdfColor` and get stored
        // verbatim as raw hex.
        updateBorderColor(palette ? (0, $gKJso.toAdfColor)(color_0, palette) : color_0);
    };
    const handleBorderOptionClick = (borderOption)=>updateBorder(borderOption);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eBTV9.CollapsibleItem), {
        title: formatMessage((0, $ff55793b554baa82$export$defe85febe8b728c).backgroundTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $ff55793b554baa82$export$defe85febe8b728c).backgroundColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        analyticsSource: "linksMenuExtensionConfigBackgroundColor",
        builtInColorMap: v2BgMap ?? (hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap),
        isReadableColor: isReadableFillColor,
        onChange: handleFillColorChange,
        value: fillPickerValue,
        pickerTitle: (0, $ff55793b554baa82$export$defe85febe8b728c).backgroundColor,
        showCustomPalette: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $ff55793b554baa82$export$defe85febe8b728c).borderPosition)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100"
    }, [
        {
            borderOption: (0, $8Yw12.BORDER).NONE,
            label: (0, $ff55793b554baa82$export$defe85febe8b728c).noBorderLabel,
            IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($bsSbN)))
        },
        {
            borderOption: (0, $8Yw12.BORDER).ALL_SIDES,
            label: (0, $ff55793b554baa82$export$defe85febe8b728c).allBordersLabel,
            IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($lRXxm)))
        },
        {
            borderOption: (0, $8Yw12.BORDER).BOTTOM,
            label: (0, $ff55793b554baa82$export$defe85febe8b728c).bottomBorderLabel,
            IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($jAG9k)))
        }
    ].map(({ borderOption: borderOption_0, label: label, IconComponent: IconComponent })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: borderOption_0,
            content: formatMessage(label)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
            xcss: (0, $w6R6I.cx)($1659d476a828e673$var$styles.borderOptionContainer, $1659d476a828e673$var$styles.border, border === borderOption_0 && $1659d476a828e673$var$styles.selected),
            onClick: ()=>handleBorderOptionClick(borderOption_0),
            testId: `border-${borderOption_0}${border === borderOption_0 ? '--selected' : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
            color: border === borderOption_0 ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon, #292A2E)",
            label: formatMessage(label)
        })));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $ff55793b554baa82$export$defe85febe8b728c).borderColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        analyticsSource: "linksMenuExtensionConfigBorderColor",
        builtInColorMap: v2BorderMap ?? (hideDefaultColorPalette ? emptyColorMap : borderColorMap),
        onChange: (color_1)=>color_1 && handleBorderColorChange(color_1),
        value: borderPickerValue,
        pickerTitle: (0, $ff55793b554baa82$export$defe85febe8b728c).borderColor,
        showCustomPalette: true
    })), isCornerRadiusEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJCWb.RangeField), {
        label: (0, $ff55793b554baa82$export$defe85febe8b728c).cornerRadius,
        minValue: (0, $4WDWC.HUB_CORNER_RADIUS_MIN),
        maxValue: (0, $4WDWC.HUB_CORNER_RADIUS_MAX),
        step: (0, $4WDWC.HUB_CORNER_RADIUS_STEP),
        value: (0, $4WDWC.resolveHubCornerRadius)((0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle === (0, $8Yw12.CORNERS).SHARP ? (0, $hjUDQ.CornerStyle).SQUARED : (0, $hjUDQ.CornerStyle).ROUNDED) ?? theming?.cornerRadius),
        updateRangeValue: updateCornerRadius,
        analyticSource: "linksMenuExtensionConfigCornerRadius",
        prefix: "cornerRadius",
        unit: "px"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1ipaC.CornerStyleConfig), {
        cornerStyleValue: cornerStyle,
        updateCornerStyle: updateCornerStyle,
        roundCornerValue: (0, $8Yw12.CORNERS).ROUND,
        squareCornerValue: (0, $8Yw12.CORNERS).SHARP
    })));
};










































const $9a3a137207e2d451$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    textTitle: {
        id: "company-hub.links-menu-extension.text.title",
        defaultMessage: "Text"
    },
    textColor: {
        id: "company-hub.links-menu-extension.text.color",
        defaultMessage: "Text color"
    },
    selectedStateColor: {
        id: "company-hub.links-menu-extension.selected.state.color",
        defaultMessage: "Selected state color"
    }
});


const $8f77d4fb60002199$export$b8599b1e18c4960e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { highlightColor: highlightColor, updateHighlightColor: updateHighlightColor, textColor: textColor, updateTextColor: updateTextColor, isReadableTextColor: isReadableTextColor } = t0;
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const { branding: branding } = (0, $cfM7x.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette } = branding ?? {};
    const { highlightColorMap: highlightColorMap, textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const theming = (0, $4pBmf.useHubTheming)();
    const isAdvancedThemingEnabled = theming?.isAdvancedThemingEnabled === true;
    const palette = isAdvancedThemingEnabled ? theming?.palette : undefined;
    const primaryColor = isAdvancedThemingEnabled ? theming?.primaryColor : undefined;
    const v2BgMap = isAdvancedThemingEnabled ? theming?.brandBackgroundColorMap : undefined;
    let t1;
    if ($[0] !== palette || $[1] !== primaryColor || $[2] !== textColor) {
        t1 = palette ? (0, $e9Sxn.resolveAdfColorForPicker)(textColor, palette, "primary.1000", primaryColor) : textColor;
        $[0] = palette;
        $[1] = primaryColor;
        $[2] = textColor;
        $[3] = t1;
    } else t1 = $[3];
    const textPickerValue = t1;
    let t2;
    if ($[4] !== highlightColor || $[5] !== palette || $[6] !== primaryColor) {
        t2 = palette ? (0, $e9Sxn.resolveAdfColorForPicker)(highlightColor, palette, "primary.1000", primaryColor) : highlightColor;
        $[4] = highlightColor;
        $[5] = palette;
        $[6] = primaryColor;
        $[7] = t2;
    } else t2 = $[7];
    const highlightPickerValue = t2;
    let t3;
    if ($[8] !== palette || $[9] !== updateTextColor) {
        t3 = (color)=>{
            updateTextColor(palette ? (0, $gKJso.toAdfColor)(color, palette) : color);
        };
        $[8] = palette;
        $[9] = updateTextColor;
        $[10] = t3;
    } else t3 = $[10];
    const handleTextColorChange = t3;
    let t4;
    if ($[11] !== palette || $[12] !== updateHighlightColor) {
        t4 = (color_0)=>{
            updateHighlightColor(palette ? (0, $gKJso.toAdfColor)(color_0, palette) : color_0);
        };
        $[11] = palette;
        $[12] = updateHighlightColor;
        $[13] = t4;
    } else t4 = $[13];
    const handleHighlightColorChange = t4;
    let t5;
    if ($[14] !== formatMessage) {
        t5 = formatMessage((0, $9a3a137207e2d451$export$defe85febe8b728c).textTitle);
        $[14] = formatMessage;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9a3a137207e2d451$export$defe85febe8b728c).textColor));
        $[16] = t6;
    } else t6 = $[16];
    const t7 = v2BgMap ?? (hideDefaultColorPalette ? emptyColorMap : textColorMap);
    let t8;
    if ($[17] !== handleTextColorChange || $[18] !== isReadableTextColor || $[19] !== t7 || $[20] !== textPickerValue) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            spread: "space-between",
            alignBlock: "center"
        }, t6, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
            analyticsSource: "linksMenuExtensionConfigTextColor",
            builtInColorMap: t7,
            isReadableColor: isReadableTextColor,
            onChange: handleTextColorChange,
            value: textPickerValue,
            pickerTitle: (0, $9a3a137207e2d451$export$defe85febe8b728c).textColor,
            showCustomPalette: true,
            showTextIcon: true
        }));
        $[17] = handleTextColorChange;
        $[18] = isReadableTextColor;
        $[19] = t7;
        $[20] = textPickerValue;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9a3a137207e2d451$export$defe85febe8b728c).selectedStateColor));
        $[22] = t9;
    } else t9 = $[22];
    const t10 = v2BgMap ?? (hideDefaultColorPalette ? emptyColorMap : highlightColorMap);
    let t11;
    if ($[23] !== handleHighlightColorChange || $[24] !== highlightPickerValue || $[25] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            spread: "space-between",
            alignBlock: "center"
        }, t9, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
            analyticsSource: "linksMenuExtensionConfigHighlightColor",
            builtInColorMap: t10,
            onChange: handleHighlightColorChange,
            value: highlightPickerValue,
            pickerTitle: (0, $9a3a137207e2d451$export$defe85febe8b728c).selectedStateColor,
            showCustomPalette: true
        }));
        $[23] = handleHighlightColorChange;
        $[24] = highlightPickerValue;
        $[25] = t10;
        $[26] = t11;
    } else t11 = $[26];
    let t12;
    if ($[27] !== t11 || $[28] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.200"
        }, t8, t11);
        $[27] = t11;
        $[28] = t8;
        $[29] = t12;
    } else t12 = $[29];
    let t13;
    if ($[30] !== t12 || $[31] !== t5) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eBTV9.CollapsibleItem), {
            title: t5
        }, t12);
        $[30] = t12;
        $[31] = t5;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
} : ({ highlightColor: highlightColor, updateHighlightColor: updateHighlightColor, textColor: textColor, updateTextColor: updateTextColor, isReadableTextColor: isReadableTextColor })=>{
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const { branding: branding } = (0, $cfM7x.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette } = branding ?? {};
    const { highlightColorMap: highlightColorMap, textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // Advanced-theming opt-in: when gate ON, swap to the 22-shade brand
    // palette and translate hex <-> ADF var-ref storage. Gate OFF or
    // non-help-center hosts (e.g. Confluence Company Hub which doesn't
    // mount the provider) take the legacy passthrough branch unchanged.
    const theming = (0, $4pBmf.useHubTheming)();
    const isAdvancedThemingEnabled = theming?.isAdvancedThemingEnabled === true;
    const palette = isAdvancedThemingEnabled ? theming?.palette : undefined;
    const primaryColor = isAdvancedThemingEnabled ? theming?.primaryColor : undefined;
    const v2BgMap = isAdvancedThemingEnabled ? theming?.brandBackgroundColorMap : undefined;
    // Text + highlight are always populated (manifest seeds a WCAG-readable
    // AK token, and useAutoTransitioningColors keeps text in sync on bg
    // change), so the fallback ref isn't hit in practice — it's only used
    // by resolveAdfColorForPicker if the stored value is null. Pass
    // primary.1000 as a sensible visible default (combo of primary.200 bg).
    const textPickerValue = palette ? (0, $e9Sxn.resolveAdfColorForPicker)(textColor, palette, 'primary.1000', primaryColor) : textColor;
    const highlightPickerValue = palette ? (0, $e9Sxn.resolveAdfColorForPicker)(highlightColor, palette, 'primary.1000', primaryColor) : highlightColor;
    const handleTextColorChange = (color)=>{
        updateTextColor(palette ? (0, $gKJso.toAdfColor)(color, palette) : color);
    };
    const handleHighlightColorChange = (color_0)=>{
        updateHighlightColor(palette ? (0, $gKJso.toAdfColor)(color_0, palette) : color_0);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eBTV9.CollapsibleItem), {
        title: formatMessage((0, $9a3a137207e2d451$export$defe85febe8b728c).textTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9a3a137207e2d451$export$defe85febe8b728c).textColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        analyticsSource: "linksMenuExtensionConfigTextColor",
        builtInColorMap: v2BgMap ?? (hideDefaultColorPalette ? emptyColorMap : textColorMap),
        isReadableColor: isReadableTextColor,
        onChange: handleTextColorChange,
        value: textPickerValue,
        pickerTitle: (0, $9a3a137207e2d451$export$defe85febe8b728c).textColor,
        showCustomPalette: true,
        showTextIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9a3a137207e2d451$export$defe85febe8b728c).selectedStateColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        analyticsSource: "linksMenuExtensionConfigHighlightColor",
        builtInColorMap: v2BgMap ?? (hideDefaultColorPalette ? emptyColorMap : highlightColorMap),
        onChange: handleHighlightColorChange,
        value: highlightPickerValue,
        pickerTitle: (0, $9a3a137207e2d451$export$defe85febe8b728c).selectedStateColor,
        showCustomPalette: true
    }))));
};


const $5e16192a3222c241$var$stylesTabStyles = (0, $buxP3.xcss)({
    width: '100%'
});
const $5e16192a3222c241$export$3989a31619203135 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { parameters: parameters, actions: actions } = t0;
    let t1;
    if ($[0] !== parameters) {
        t1 = parameters ?? {};
        $[0] = parameters;
        $[1] = t1;
    } else t1 = $[1];
    const { styles: styles } = t1;
    const { updateBorder: updateBorder, updateBorderColor: updateBorderColor, updateCornerRadius: updateCornerRadius, updateCornerStyle: updateCornerStyle, updateFillColor: updateFillColor, updateHighlightColor: updateHighlightColor, updateTextColor: updateTextColor } = actions;
    let t2;
    if ($[2] !== styles.textColor) {
        t2 = (color)=>(0, $4yUlE.isReadable)(color, styles.textColor);
        $[2] = styles.textColor;
        $[3] = t2;
    } else t2 = $[3];
    const isReadableFillColor = t2;
    let t3;
    if ($[4] !== styles.fillColor) {
        t3 = (color_0)=>(0, $4yUlE.isReadable)(color_0, styles.fillColor);
        $[4] = styles.fillColor;
        $[5] = t3;
    } else t3 = $[5];
    const isReadableTextColor = t3;
    const { branding: branding } = (0, $cfM7x.useProductDependencies)();
    (0, $5ddnJ.useAutoTransitioningColors)(styles.fillColor, isReadableTextColor, styles.textColor, updateTextColor, branding?.defaultParameters);
    let t4;
    if ($[6] !== actions.updateAlignment || $[7] !== parameters.styles.alignment) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8df22c16dac442a4$export$f77ede0ff8fdecea), {
            updateAlignment: actions.updateAlignment,
            alignment: parameters.styles.alignment
        });
        $[6] = actions.updateAlignment;
        $[7] = parameters.styles.alignment;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== isReadableFillColor || $[10] !== styles.border || $[11] !== styles.borderColor || $[12] !== styles.cornerRadius || $[13] !== styles.cornerStyle || $[14] !== styles.fillColor || $[15] !== updateBorder || $[16] !== updateBorderColor || $[17] !== updateCornerRadius || $[18] !== updateCornerStyle || $[19] !== updateFillColor) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1659d476a828e673$export$caf212aab59548f5), {
            border: styles.border,
            updateBorder: updateBorder,
            borderColor: styles.borderColor,
            updateBorderColor: updateBorderColor,
            fillColor: styles.fillColor,
            updateFillColor: updateFillColor,
            cornerStyle: styles.cornerStyle,
            updateCornerStyle: updateCornerStyle,
            cornerRadius: styles.cornerRadius,
            updateCornerRadius: updateCornerRadius,
            isReadableFillColor: isReadableFillColor
        });
        $[9] = isReadableFillColor;
        $[10] = styles.border;
        $[11] = styles.borderColor;
        $[12] = styles.cornerRadius;
        $[13] = styles.cornerStyle;
        $[14] = styles.fillColor;
        $[15] = updateBorder;
        $[16] = updateBorderColor;
        $[17] = updateCornerRadius;
        $[18] = updateCornerStyle;
        $[19] = updateFillColor;
        $[20] = t5;
    } else t5 = $[20];
    let t6;
    if ($[21] !== isReadableTextColor || $[22] !== styles.highlightColor || $[23] !== styles.textColor || $[24] !== updateHighlightColor || $[25] !== updateTextColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8f77d4fb60002199$export$b8599b1e18c4960e), {
            highlightColor: styles.highlightColor,
            updateHighlightColor: updateHighlightColor,
            textColor: styles.textColor,
            updateTextColor: updateTextColor,
            isReadableTextColor: isReadableTextColor
        });
        $[21] = isReadableTextColor;
        $[22] = styles.highlightColor;
        $[23] = styles.textColor;
        $[24] = updateHighlightColor;
        $[25] = updateTextColor;
        $[26] = t6;
    } else t6 = $[26];
    let t7;
    if ($[27] !== t4 || $[28] !== t5 || $[29] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            direction: "column",
            xcss: $5e16192a3222c241$var$stylesTabStyles
        }, t4, t5, t6);
        $[27] = t4;
        $[28] = t5;
        $[29] = t6;
        $[30] = t7;
    } else t7 = $[30];
    return t7;
} : ({ parameters: parameters, actions: actions })=>{
    const { styles: styles } = parameters ?? {};
    const { updateBorder: updateBorder, updateBorderColor: updateBorderColor, updateCornerRadius: updateCornerRadius, updateCornerStyle: updateCornerStyle, updateFillColor: updateFillColor, updateHighlightColor: updateHighlightColor, updateTextColor: updateTextColor } = actions;
    const isReadableFillColor = (color)=>(0, $4yUlE.isReadable)(color, styles.textColor);
    const isReadableTextColor = (color_0)=>(0, $4yUlE.isReadable)(color_0, styles.fillColor);
    const { branding: branding } = (0, $cfM7x.useProductDependencies)();
    (0, $5ddnJ.useAutoTransitioningColors)(styles.fillColor, isReadableTextColor, styles.textColor, updateTextColor, branding?.defaultParameters);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "column",
        xcss: $5e16192a3222c241$var$stylesTabStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8df22c16dac442a4$export$f77ede0ff8fdecea), {
        updateAlignment: actions.updateAlignment,
        alignment: parameters.styles.alignment
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1659d476a828e673$export$caf212aab59548f5), {
        border: styles.border,
        updateBorder: updateBorder,
        borderColor: styles.borderColor,
        updateBorderColor: updateBorderColor,
        fillColor: styles.fillColor,
        updateFillColor: updateFillColor,
        cornerStyle: styles.cornerStyle,
        updateCornerStyle: updateCornerStyle,
        cornerRadius: styles.cornerRadius,
        updateCornerRadius: updateCornerRadius,
        isReadableFillColor: isReadableFillColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8f77d4fb60002199$export$b8599b1e18c4960e), {
        highlightColor: styles.highlightColor,
        updateHighlightColor: updateHighlightColor,
        textColor: styles.textColor,
        updateTextColor: updateTextColor,
        isReadableTextColor: isReadableTextColor
    }));
};


const $6e1151b045a252d2$var$SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/set-up-a-menu-of-important-links-on-company-hub/';
const $6e1151b045a252d2$var$stickyFooterStyles = (0, $buxP3.xcss)({
    paddingInline: 'space.050',
    paddingBlock: 'space.300',
    marginInline: 'space.negative.050',
    display: 'flex',
    flexDirection: 'column',
    position: 'sticky',
    bottom: 'space.0',
    backgroundColor: 'elevation.surface'
});
const $6e1151b045a252d2$var$LinksMenuFooter = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $6e1151b045a252d2$var$stickyFooterStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dDC4.ConfigPanelFeedbackCollector), {
            source: "linksMenuExtension",
            type: (0, $hjUDQ.FeedbackType).LINKS_MENU
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $6e1151b045a252d2$var$stickyFooterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dDC4.ConfigPanelFeedbackCollector), {
        source: "linksMenuExtension",
        type: (0, $hjUDQ.FeedbackType).LINKS_MENU
    }));
const $6e1151b045a252d2$export$d4ee58941fdf2d2c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showConfigPreambleSupportLink: showConfigPreambleSupportLink } = (0, $cfM7x.useProductDependencies)();
    let t1;
    if ($[0] !== editorActions || $[1] !== localId) {
        t1 = {
            localId: localId,
            editorActions: editorActions
        };
        $[0] = editorActions;
        $[1] = localId;
        $[2] = t1;
    } else t1 = $[2];
    const { extensionParameters: extensionParameters, extensionActions: extensionActions } = (0, $5a630f948a937af8$export$579466658e10543a)(t1);
    if (!extensionParameters) return null;
    let t2;
    if ($[3] !== formatMessage) {
        t2 = formatMessage((0, $4ea311f5ca17d214$export$defe85febe8b728c).itemsLabel);
        $[3] = formatMessage;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== extensionActions || $[6] !== extensionParameters) {
        t3 = [
            {
                sectionId: "main",
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $56913d8e8d66d0b7$export$869bcddc95554001), {
                    extensionParameters: extensionParameters,
                    extensionActions: extensionActions
                })
            }
        ];
        $[5] = extensionActions;
        $[6] = extensionParameters;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t2 || $[9] !== t3) {
        t4 = {
            label: t2,
            value: "items",
            tabContent: t3
        };
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== formatMessage) {
        t5 = formatMessage((0, $4ea311f5ca17d214$export$defe85febe8b728c).stylesLabel);
        $[11] = formatMessage;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== extensionActions || $[14] !== extensionParameters) {
        t6 = [
            {
                sectionId: "general",
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5e16192a3222c241$export$3989a31619203135), {
                    parameters: extensionParameters,
                    actions: extensionActions
                })
            }
        ];
        $[13] = extensionActions;
        $[14] = extensionParameters;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== t5 || $[17] !== t6) {
        t7 = {
            label: t5,
            value: "styles",
            tabContent: t6
        };
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== t4 || $[20] !== t7) {
        t8 = [
            t4,
            t7
        ];
        $[19] = t4;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    const tabSections = t8;
    let t9;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $4ea311f5ca17d214$export$defe85febe8b728c).title);
        $[22] = t9;
    } else t9 = $[22];
    const t10 = showConfigPreambleSupportLink ? (0, $4ea311f5ca17d214$export$defe85febe8b728c).preamble : (0, $4ea311f5ca17d214$export$defe85febe8b728c).preambleWithoutSupportLink;
    let t11;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = {
            linksMenuSupportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                target: "_blank",
                href: $6e1151b045a252d2$var$SUPPORT_LINK
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $4ea311f5ca17d214$export$defe85febe8b728c).preambleSupportLinkLabel))
        };
        $[23] = t11;
    } else t11 = $[23];
    let t12;
    if ($[24] !== t10) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...t10,
            values: t11
        }));
        $[24] = t10;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== tabSections) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4zyjT.ConfigPanelGrouping), {
            source: "linksMenuExtensionConfig",
            tabSections: tabSections
        });
        $[26] = tabSections;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== closeConfigPanel || $[29] !== t12 || $[30] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a96iv.ExtensionsConfigWrapper), {
            title: t9,
            footerComponent: $6e1151b045a252d2$var$LinksMenuFooter,
            closeConfigPanel: closeConfigPanel
        }, t12, t13);
        $[28] = closeConfigPanel;
        $[29] = t12;
        $[30] = t13;
        $[31] = t14;
    } else t14 = $[31];
    return t14;
} : ({ closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showConfigPreambleSupportLink: showConfigPreambleSupportLink } = (0, $cfM7x.useProductDependencies)();
    const { extensionParameters: extensionParameters, extensionActions: extensionActions } = (0, $5a630f948a937af8$export$579466658e10543a)({
        localId: localId,
        editorActions: editorActions
    });
    if (!extensionParameters) return null;
    const tabSections = [
        {
            label: formatMessage((0, $4ea311f5ca17d214$export$defe85febe8b728c).itemsLabel),
            value: 'items',
            tabContent: [
                {
                    sectionId: 'main',
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $56913d8e8d66d0b7$export$869bcddc95554001), {
                        extensionParameters: extensionParameters,
                        extensionActions: extensionActions
                    })
                }
            ]
        },
        {
            label: formatMessage((0, $4ea311f5ca17d214$export$defe85febe8b728c).stylesLabel),
            value: 'styles',
            tabContent: [
                {
                    sectionId: 'general',
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5e16192a3222c241$export$3989a31619203135), {
                        parameters: extensionParameters,
                        actions: extensionActions
                    })
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a96iv.ExtensionsConfigWrapper), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $4ea311f5ca17d214$export$defe85febe8b728c).title),
        footerComponent: $6e1151b045a252d2$var$LinksMenuFooter,
        closeConfigPanel: closeConfigPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...showConfigPreambleSupportLink ? (0, $4ea311f5ca17d214$export$defe85febe8b728c).preamble : (0, $4ea311f5ca17d214$export$defe85febe8b728c).preambleWithoutSupportLink,
        values: {
            linksMenuSupportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                target: "_blank",
                href: $6e1151b045a252d2$var$SUPPORT_LINK
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $4ea311f5ca17d214$export$defe85febe8b728c).preambleSupportLinkLabel))
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4zyjT.ConfigPanelGrouping), {
        source: "linksMenuExtensionConfig",
        tabSections: tabSections
    }));
};
module.exports["LinksMenuConfigPanelContent"] = $6e1151b045a252d2$export$d4ee58941fdf2d2c;

});


//# sourceMappingURL=links-menu-extension.e08e6e0b.js.map
